import React, {useState, useEffect, useRef, useCallback, useMemo  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { faServer, faVideoCamera, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { RingLoader } from 'react-spinners';
// leaflet
import { MapContainer, TileLayer, Marker, LayersControl, LayerGroup, Tooltip, useMap } from 'react-leaflet';
import { Icon, LatLng, LatLngBounds } from 'leaflet';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';

// import vms logos
import vms_milestone from '../../images/vms_milestone.png';
import vms_nx from '../../images/vms_nx.png';
import vms_avigilon from '../../images/vms_avigilon.png';
import vms_wisenet from '../../images/vms_wisenet.png';
import vms_dw from '../../images/vms_dw.png';

// import site group icon
import siteGroupIcon from '../../images/site-group.svg';

import "leaflet/dist/leaflet.css";
import './customStyle.css'; // Custom CSS 
import './AnalyticInfo.css';
import '../matterport/MatterportViewer.css';

// Hive images

import Home from '../home/Home';
import { canAccess, webURL } from '../../config';

import { listServers } from '../../redux/actions/serverActions';
import { fetchSelectedBusiness } from '../../redux/actions/fetchSelectedBusinessActions';
import OfflineServersPastWeek from './OfflineServersPastWeek';
import OfflineDevicesPastWeek from './OfflineDevicesPastWeek';
import UnAckAlerts from './UnAckAlerts';
import HealthCharts from './HealthCharts';
import OfflineErrorMsg from './OfflineErrorMsg';

import '../../../src/styles/healthInfo.css';

import SideBarSmallScreen from '../SideBarSmallScreen';
import CustomTooltipPortLayout from '../tooltips/CustomTooltipPortLayout'

import PORT_UP_WHITE_ICON from '../../images/port-up-white.png';
import PORT_UP_BORDER_ICON from '../../images/port-up-border-green.png';

import PORT_UP_ICON from '../../images/port-up.png';
import PORT_DOWN_ICON from '../../images/port-down.png';

import Port from './Port';
import OnboardingSite from './OnboardingSite';
import {newFeature} from '../../redux/actions/newFeature';
import OnboardingBusiness from './OnboardingBusiness';
import SitePlan from './sitemap/SitePlan';

import { listDevicesPerSite } from '../../redux/actions/listDevicesPerSite';
import { listPlacedCamPositions } from '../../redux/actions/listPlacedCamPositions';

import DragOverlay from './sitemap/DragOverlay';
import { businessTokenMapping } from '../../redux/actions/businessTokenMappingActions';
import { url } from '../../api/endpointURL';


import DeviceInfoIcon from './ninja/DeviceInfoIcon';
import NinjaDetails from './ninja/NinjaDetails';
import SelectedServer from './SelectedServer';
import { API } from '../../api';

// Generic components
import Table from '../../generic_components/Table/Table';
import GenericTooltip from '../../generic_components/Tooltip/Tooltip';
import Select from '../../generic_components/Select/Select';
import Modal from '../../generic_components/Modal/Modal';
import Footer from '../../generic_components/Footer/Footer';
import Card from '../../generic_components/Card/Card';
import { useToast } from '../../generic_components/Toast/Toast';
import OnlineSuccessMsg from './OnlineSuccessMsg';

// matterport
import MatterportModelViewer from '../matterport/MatterportViewer';
import CameraTagMapping from '../matterport/Cameratagmapping';
import MatterportConfig from '../matterport/MatterportConfig';

// site grouping imports
import SiteGroupManager from './siteGroup/SiteGroupManager';

const Servers = ({soundEnabled}) => {  
  const mapRef = useRef(null);
  const [selectedBusiness, setSelectedBusiness] = useState(localStorage.getItem('selectedBusiness') || ''); 
  const [selectedSite, setSelectedSite] = useState('All');
  const [selectedVMS, setSelectedVMS] = useState('All');
  const [selectedSI, setSelectedSI] = useState('');
  const [loadingSelectedBusiness, setLoadingSelectedBusiness] = useState(false);
  const [isHealthTableVisible, setIsHealthTableVisible] = useState(false);
  const [isStorageTableVisible, setIsStorageTableVisible] = useState(false);
  const [isHealthyAnalyticsTableVisible, setIsHealthyAnalyticsTableVisible] = useState(false);
  const [isHealthyUPSTableVisible, setIsHealthyUPSTableVisible] = useState(false);
  const [isHealthySwitchesTableVisible, setIsHealthySwitchesTableVisible] = useState(false);
  const [isPortLayoutVisible, setIsPortLayoutVisible] = useState(false);
  const [is2DSitePlanVisible, setIs2DSitePlanVisible] = useState(false);
  const [pinSiteName, setPinSiteName] = useState('');
  const [hwid, setHwid] = useState('');
  const [technicianSites, setTechnicianSites] = useState([]);
  const [userBusinessRole, setUserBusinessRole] = useState(null);
  const [businessNoSites, setBusinessNoSites] = useState([]);
  const [ackNote, setAckNote] = useState('');
  const [showAckStatus, setShowAckStatus] = useState(false);

  const [showPastWkOfflineServer, setShowPastWkOfflineServer] = useState(false);
  const [showPastWkOfflineDevices, setShowPastWkOfflineDevices] = useState(false);
  const [showUnAckAlerts, setShowUnAckAlerts] = useState(false);
  const [date,setDate] = useState(new Date());
  const [mapRefLoaded, setMapRefLoaded] = useState(false);
  const [center, setCenter] = useState([0, 0]);
  const [sortConfigHealthy, setsortConfigHealthyHealthy] = useState({ key: 'serverOnlineDays', direction: 'descending' });
  const [sortConfigAlerts, setsortConfigAlerts] = useState({ key: 'serverStatus', direction: 'ascending' });
  const { BaseLayer, Overlay } = LayersControl;
  const [initialLoad, setInitialLoad] = useState(true);

  let onlineAudio = useRef(null);
  let offlineAudio = useRef(null);

  const [highlightedTable, setHighlightedTable] = useState(null);
  const [soundAllowedBrowser, setSoundAllowedBrowser] = useState(true);

  const alertTableRefs = useRef({});

  const toast = useToast();

  // site grouping
  const [siteGroups, setSiteGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('all');
  const [isGroupingActive, setIsGroupingActive] = useState(false); 
  const [showGroupManager, setShowGroupManager] = useState(false);

  // matterport modal
  const [showMatterportModal, setShowMatterportModal] = useState(false);
  const [selectedMatterPortModelId, setSelectedMatterportModelId] = useState('');

  // Matterport or General 2D sit emodel selection model
  const [showSitePlanTypeModal, setShowSitePlanTypeModal] = useState(false);

  // Matterport configuration modal
  const [showMatterportModelConfig, setShowMatterportModelConfig] = useState(false);
  const [showMatterportModelEdit, setShowMatterportModelEdit] = useState(false);
  const [showMatterportUnmapWarning, setShowMatterportUnmapWarning] = useState(false);
  const [tags, setTags] = useState([]);
  const [editMode, setEditMode] = useState(false);


  // handle close matterport modal
  const handleCloseMatterportModal = () => {
    setShowMatterportModal(false);
    // reset edit tag mode
    setEditMode(false);
  };

  // handle close site plan type modal
  const handleCloseSitePlanTypeModal = () => {
    setShowSitePlanTypeModal(false);
  };

  // handle close matterport model config modal
  const handleCloseMatterportModelConfig = () => {
    setShowMatterportModelConfig(false);
  };

  // handle close matterport unmap warning modal
  const handleCloseMatterportUnmapWarningModal = () => {
    setShowMatterportUnmapWarning(false);
  };

  const handleCloseGroupManager = () => {
  setShowGroupManager(false);
  fetchSiteGroups(); // Refresh groups after closing
};
  
const handleMappterportEditOrConfig = async() => {
  try {
    const matterPortModelId = await fetchMatterportModelId(hwid);
    if (matterPortModelId) {
      setShowMatterportModal(true);
      setSelectedMatterportModelId(matterPortModelId);
      await setMatterportTags(matterPortModelId); // fetch and set tags before showing the modal
  } else {
      setShowMatterportModelConfig(true);
  }
  // close the site plan type selection modal in either case
  handleCloseSitePlanTypeModal();

  } catch (error) {
    console.error('Error determining whether to show Matterport modal or config:', error);
    setIs2DSitePlanVisible(true); // fallback to general site plan if there's an error
  }
}

  const MAX_LENGTH = 255;
 
  const isSmallScreen = window.innerWidth < 600;

  const user = localStorage.getItem('email');

  const dispatch = useDispatch();


  
  const fetchUserResponse = useSelector(state => state.fetchUserResponse);
  const businesses = fetchUserResponse?.businesses;
  const filteredSites = businesses?.filter(obj => obj[selectedBusiness] !== undefined);

  // Extracting values from filtered sites
  const selectedSites = useMemo(() => {
    if (!selectedBusiness) return [];
    return filteredSites?.flatMap(obj => Object.values(obj))[0] || [];
  }, [selectedBusiness, filteredSites])

  // Filter technician sites
  const filteredTechnicianSites = useMemo(() => {
    if (!selectedBusiness) return [];
    return technicianSites?.filter(obj => obj.business === selectedBusiness) || []
  }, [selectedBusiness, technicianSites]);

  // Extracting values from filtered sites
  const selectedTechnicianSites = useMemo(() => {
    if (!selectedBusiness) return [];
    return filteredTechnicianSites?.flatMap(obj => obj.site) || [];
  }, [selectedBusiness, filteredTechnicianSites]);

  // If the user is a technician, render specific sites assigned to them otherwise show all sites for the selected business
  const sortedSites = useMemo(() => {
    return [...new Set(userBusinessRole==='technician'
      ? selectedTechnicianSites.map((site) => site) 
      : selectedSites.map((site) => site))].sort();
  }, [userBusinessRole, selectedTechnicianSites, selectedSites]);

  const fetchSiteGroups = useCallback(async () => {
  try {
    const response = await fetch(`${url}/site-groups/${encodeURIComponent(selectedBusiness)}`);
    if (response.ok) {
      const data = await response.json();
      // exclude groups if sites not assoicated in the site list (for technician role)
      const filteredData = data.filter(g =>
          g.sites.every(s => sortedSites.includes(s.site_name) && s.site_name !== "All")
      );
      setSiteGroups(filteredData);
      setIsGroupingActive(data.length > 0);
      
      //if no groups returned
      if (data.length === 0) {       
      setSiteGroups([]);
      setIsGroupingActive(false);
      }

    }
  } catch (error) {
    console.error('Error fetching site groups:', error);
    setSiteGroups([]);
    setIsGroupingActive(false);
  }
}, [selectedBusiness, sortedSites]); // Add selectedBusiness as dependency

// Keep only ONE useEffect - remove the duplicate
useEffect(() => {
  if (selectedBusiness) {
    fetchSiteGroups();
  } else {
    setSiteGroups([]);
    setSelectedGroup('all');
    setIsGroupingActive(false);
  }
}, [selectedBusiness, fetchSiteGroups]); 

// Get group options (only shown when grouping is active)
const groupOptions = useMemo(() => {
  if (!isGroupingActive) return [];
  
  const options = [{ label: 'All Groups', value: 'all' }];
  
  siteGroups.forEach(group => {
    // Safety check: ensure group has id and group_name
    if (group && group.id && group.group_name) {
      options.push({
        label: group.group_name,
        value: group.id.toString()
      });
    }
  });
  
  return options;
}, [siteGroups, isGroupingActive]);

const sortedSitesOptions = sortedSites?.map((site, index) => (
  {
  label: site,
  value: site
  }
));

// Site options based on grouping status and selected group
const displayedSitesOptions = useMemo(() => {
  const filteredSortedSites = sortedSitesOptions.filter(
    option => option.label !== 'All' && option.value !== 'All'
  );

  // No grouping active
  if (!isGroupingActive) {
    return [
      { label: 'All Sites', value: 'All' },
      ...filteredSortedSites
    ];
  }

  // Grouping active, all groups selected
  if (selectedGroup === 'all') {
    return [
      { label: 'All Sites', value: 'All' },
      ...filteredSortedSites
    ];
  }

  // Specific group selected
  const group = siteGroups.find(
    g => g?.id?.toString() === selectedGroup
  );

  if (!group || !Array.isArray(group.sites)) {
    return [{ label: 'All Sites', value: 'All' }];
  }

  return [
    { label: 'All Sites', value: 'All' },
    ...group.sites
      .filter(s => s?.site_name && s.site_name !== 'All')
      .map(s => ({
        label: s.site_name,
        value: s.site_name
      }))
  ];
}, [isGroupingActive, selectedGroup, siteGroups, sortedSitesOptions]);


// Handle group selection
const handleGroupChange = (event) => {
  const newGroup = event.target.value;
  setSelectedGroup(newGroup);
  setSelectedSite('All'); // Reset site to 'All' when group changes
};

// Handle site selection (keep as is)
const handleSiteChange = (event) => {
  setSelectedSite(event.target.value);
  const si = getSIfromSite(event.target.value);
  setSelectedSI(si);
};



  const handleShowAckModal = (server) => {
    setSelectedServer(server);
    setShowAckStatus(true);
  };

  const handleSortHealthy = (columnKey) => {
    let direction = 'ascending';
    if (sortConfigHealthy.key === columnKey && sortConfigHealthy.direction === 'ascending') {
      direction = 'descending';
    }
    setsortConfigHealthyHealthy({ key: columnKey, direction });
  };

  const handleSortAlert = (columnKey) => {
    let direction = 'ascending';
    if (sortConfigAlerts.key === columnKey && sortConfigAlerts.direction === 'ascending') {
      direction = 'descending';
    }
    setsortConfigAlerts({ key: columnKey, direction });
  };

  // Get the current user level for the business.If rbac = 'tla', user role should be 'tla'
  useEffect(() => {
    let userRole = localStorage.getItem('rbac_role')?.toLowerCase();
    setUserBusinessRole(userRole);
    if (userRole !== 'tla') {
      try {
        // Get the current user level for the business
        // get user business role from fetchUserResponse redux state
        const userBusinessRole = fetchUserResponse.businesses?.find(b => b[selectedBusiness])?.role ?? null;
        setUserBusinessRole(userBusinessRole?.toLowerCase());
        //const businessRoles = JSON.parse(localStorage.getItem('rbac_data')) || [];
        //setUserBusinessRole(businessRoles.find(businessRole => businessRole.business === selectedBusiness)?.role?.toLowerCase());
        } catch (e) {
            console.error('Error parsing rbac_data:', e);
        }
    }
  }, [selectedBusiness, fetchUserResponse.businesses])

  // Function to fetch technician sites
  const fetchTechnicianSites = async (email) => {
    try {
      // Add year parameter to technician sites API call
      const response = await fetch(`${url}/technicianSites?email=${encodeURIComponent(email)}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          console.log('No technician sites found for user');
          setTechnicianSites([]);
          return [];
        }
        throw new Error(`Failed to fetch technician sites: ${response.status}`);
      }
      
      const sites = await response.json();
      // console.log('Fetched technician sites ', ':', sites);
      setTechnicianSites(sites);
      return sites;
    } catch (error) {
      console.error("Error fetching technician sites:", error);
      setTechnicianSites([]);
      return [];
    }
  };

  // Fetch technician sites
  useEffect(() => {
    const email = localStorage.getItem('email');
    if (!email) return;
    // If the user role for selected business is a technician, fetch the technician sites
    if(userBusinessRole === 'technician'){
      fetchTechnicianSites(email);
    }
  }, [userBusinessRole, fetchUserResponse.businesses, selectedBusiness]);



  // Total data
  const serversResponseData = useSelector(state => state.serversData);
  let servers = serversResponseData.servers;
  const serversResponsecode = serversResponseData.code;
  const analytics = serversResponseData.analytics;

  // Get the audio object given audio src
  const getAudio = (audio, src) => {
    if (!audio.current) {
      audio.current = document.createElement("audio");
      audio.current.src = src;
      audio.current.preload = "auto";
    }
    return audio.current;
  };

  // Handle first user interaction on the page
  const handleUserInteract = useCallback(() => {
    setSoundAllowedBrowser(true);
    toast.success('Audio has been enabled! 🔊 ',{
      autoClose: 10000
    });
  }, [toast]);

  // Capture first user interaction on the page
  useEffect(() => {
    if (!soundAllowedBrowser) {
      // Listen once
      window.addEventListener('click', handleUserInteract, { once: true });
      window.addEventListener('touchstart', handleUserInteract, { once: true });
    }
    return () => {
      window.removeEventListener('click', handleUserInteract);
      window.removeEventListener('touchstart', handleUserInteract);
    };
  }, [soundAllowedBrowser, handleUserInteract]);
  
  // Play audio sound
  const playSound = useCallback((audio, src) => {
    // If sound isn't enabled, exit function
    if (!soundEnabled) return;
    // Otherwise
    const sound = getAudio(audio, src);
    // Reset the audio to the start
    sound.currentTime = 0;
    // Play the audio
    sound.play().catch((error) => {
      console.warn(`Audio blocked. ${error}`);
      setSoundAllowedBrowser(false);
      const warningMsg = (
        <div className="audio-warning-msg">
          <p>Browser blocks audio until you interact with the page.</p> 
          <p><b> Click/Tap anywhere </b> on the page to enable <b>audio alerts</b>.</p>
          <div>
          <a
            href="https://goo.gl/xX8pDD"
            target="_blank"
            rel="noopener noreferrer"
            className="audio-warning-link"
            >
              Learn more
          </a>
          {' '}
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{color: 'grey'}}/>
          </div>
        </div>
      )
      toast.warning(warningMsg, {
        autoClose: 10000,
      });
    });
  }, [soundEnabled, toast]);

  // Scroll to alerts table
  const scrollToAlertsTable = (tableLabel) => {
    alertTableRefs.current[tableLabel]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Clear the highlight first
    setHighlightedTable(null);

    // Re-apply the highlight on the next animation frame
    requestAnimationFrame(() => {
      setHighlightedTable(tableLabel);
    });
  };

  // Servers, cameras, storage, ups, switch
  const serversPrevState = useRef([]);

  useEffect(() => {
    const serversPrev = serversPrevState.current;

    // 1. Skip on first render
    if (!serversPrev || serversPrev.length === 0) {
      serversPrevState.current = servers;
      return;
    }

    //                                   ** SERVER ALERT(s) **

   // If serverId is not empty, key = hwid + serverId otherwise key = hwid + serverName
    const getKey = (s) =>
      s.serverId
        ? `${s.hwid || 'no-hwid'} | ${s.serverId}`
        : `${s.hwid || 'no-hwid'} | ${s.serverName}`;

    // Convert previous array to a lookup map: { [serverId]: server }
    const serversPrevMap = Object.fromEntries(serversPrev.map(s => [getKey(s), s]));

    // For each current server, compare its current status with its previous status
    servers.forEach(currServer => {
      // Get the previous server based on serverId
      const key = getKey(currServer);
      const prevServer = serversPrevMap[key];

      // If it's a completely new server
      if (!prevServer) {
        return; // skip to the next server
      }

      // Server Status Changed
      if (prevServer.serverStatus !== currServer.serverStatus) {
        if (prevServer.serverStatus === 'Online' && currServer.serverStatus === 'Offline') {
          const errorMsg = ( 
            <div>
              <h4 className='server-heading'>
                Server Offline
              </h4>
              <p>
                Server <span className='highlight-text'>{currServer.serverName}</span> at Site <span className='highlight-text'>{currServer.site}</span> has gone offline.
              </p>
              <div className="refer-container">
                <button className="refer-table-btn" onClick={() => scrollToAlertsTable('servers')}>
                  View Server Alerts Table <i className="fas fa-external-link"></i>
                </button>
              </div>
            </div>
          )
          playSound(offlineAudio, '/sounds/offline.mp3');
          toast.error(errorMsg, {
            autoClose: 20000,
          });
        }

        if (prevServer.serverStatus === 'Offline' && currServer.serverStatus === 'Online') {
          const successMsg = ( 
            <div>
              <h4 className='server-heading'>
                Server Online
              </h4>
              <p>
                Server <span className='highlight-text'>{currServer.serverName}</span> at Site <span className='highlight-text'>{currServer.site}</span> is back online.
              </p>
            </div>
          );
          playSound(onlineAudio, '/sounds/online.mp3');
          toast.success(successMsg, {
            autoClose: 10000,
          });
        }
      }

      //                                  ** CAMERA ALERT(s) **
      // Only show toast regarding cameras gone offline events when server is Online
      if (prevServer.serverStatus === 'Online' && currServer.serverStatus === 'Online') {
        const prevOfflineCams = prevServer.offlineCamList || [];
        const currOfflineCams = currServer.offlineCamList || []; 

        // Previous offline cameras map
        const prevOfflineMap = Object.fromEntries(prevOfflineCams.map(c => [c.cameraId, c]));
        const uniquePrevOfflineCams = Object.values(prevOfflineMap); // unique

        // Current offline cameras map
        const currOfflineMap = Object.fromEntries(currOfflineCams.map(c => [c.cameraId, c]));
        const uniqueCurrOfflineCams = Object.values(currOfflineMap); // unique

        // Newly offline cameras won't exist in previous offline camera list
        const newlyOfflineCam = uniqueCurrOfflineCams.filter(cam => !prevOfflineMap[cam.cameraId]);

        if (newlyOfflineCam.length > 0) {
          playSound(offlineAudio, '/sounds/offline.mp3');
          toast.error(
            <OfflineErrorMsg
              serverName={currServer.serverName}
              newlyOfflineCam={newlyOfflineCam}
            />
            , {
            autoClose: 20000,
          });
        }

        // Back to online cameras won't exist in current offline camera list
        const backOnlineCam = uniquePrevOfflineCams.filter(cam => !currOfflineMap[cam.cameraId]);

        if (backOnlineCam.length > 0) {
          playSound(onlineAudio, '/sounds/online.mp3');
          toast.success(
            <OnlineSuccessMsg 
              serverName={currServer.serverName}
              backOnlineCam={backOnlineCam}
            />
            , {
            autoClose: 10000,
          });
        }
      }

      //                                   ** STORAGE ALERT(s) **
      // Convert previous storage array to a lookup map: { [storageId]: storage }
      const prevStorageMap = Object.fromEntries(prevServer.storage.map(st => [st.storageId, st]));

      // For each current storage, check its current status with previous status
      currServer.storage.forEach((currStorage) => {
        const prevStorage = prevStorageMap[currStorage.storageId];

        // If it's a completely new storage
        if (!prevStorage) {
          return; // skip to next storage
        }

        // Storage Status Changed
        if (prevStorage.storageStatus !== currStorage.storageStatus) {
          if (prevStorage.storageStatus === 'Online' && currStorage.storageStatus === 'Offline') {
            const errorMsg = ( 
              <div>
                <h4 className='server-heading'>
                  Storage Offline
                </h4>
                <p>
                  Storage ID <span className='highlight-text'>{currStorage.storageId}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> has gone offline.             
                </p>
                <div className="refer-container">
                  <button className="refer-table-btn" onClick={() => scrollToAlertsTable('storages')}>
                    View Storage Alerts Table <i className="fas fa-external-link"></i>
                  </button>
                </div>
              </div>
            )
            playSound(offlineAudio, '/sounds/offline.mp3');
            toast.error(errorMsg, {
              autoClose: 20000,
            });
          }
          if (prevStorage.storageStatus === 'Offline' && currStorage.storageStatus === 'Online') {
            const successMsg = ( 
              <div>
                <h4 className='server-heading'>
                  Storage Online
                </h4>
                <p>
                  Storage ID <span className='highlight-text'>{currStorage.storageId}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> is back online.             
                </p>
              </div>
            )
            playSound(onlineAudio, '/sounds/online.mp3');
            toast.success(successMsg, {
              autoClose: 10000,
            });
          }
        }
      });

      //                                    ** UPS ALERT(s) **
      // Convert previous storage array to a lookup map: { [storageId]: storage }
      const getInfoKey = (a) => 
        a.info_type 
          ? `${a.info_type}-${a.info_id}`
          : `${a.info_label}-${a.info_id}`;

      const prevUPSMap = Object.fromEntries(prevServer.additionalInfo.map(st => [getInfoKey(st), st]));

      currServer.additionalInfo.forEach((currInfo) => {
        const prevUPS = prevUPSMap[getInfoKey(currInfo)];

        if (!prevUPS) return;  // If new UPS is added, ignore 
        
        if (prevUPS.info_status === 'Online' && currInfo.info_status === 'Offline') {
          const errorMsg = ( 
            <div>
              <h4 className='server-heading'>
                {currInfo.info_type} Offline
              </h4>
              <p>
                Device with label <span className='highlight-text'> {currInfo.info_label}</span> and ID <span className='highlight-text'>{currInfo.info_id}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> has gone offline.             
              </p>
              <div className="refer-container">
                <button className="refer-table-btn" onClick={() => scrollToAlertsTable('ups')}>
                  View {currInfo.info_type} Alerts Table  <i className="fas fa-external-link"></i>
                </button>
              </div>
            </div>
          )
          playSound(offlineAudio, '/sounds/offline.mp3');
          toast.error(errorMsg, {
            autoClose: 20000,
          });
        }
        if (prevUPS.info_status === 'Offline' && currInfo.info_status === 'Online') {
          const successMsg = ( 
            <div>
              <h4 className='server-heading'>
                {currInfo.info_type} Online
              </h4>
              <p>
                Device with label <span className='highlight-text'> {currInfo.info_label}</span> and ID <span className='highlight-text'>{currInfo.info_id}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> is back online.             
              </p>
            </div>
          )
          playSound(onlineAudio, '/sounds/online.mp3');
          toast.success(successMsg, {
            autoClose: 10000,
          });
        }
      });


      //                                   ** SWITCH ALERT(s) - only one each server **
      const prevSwitch = prevServer.switchInfo;
      const currSwitch = currServer.switchInfo;

      if (!prevSwitch || !currSwitch) return; // Skip to next server

      if (prevSwitch.switch_id === currSwitch.switch_id) {
        if (prevSwitch.switch_status === 1 && currSwitch.switch_status === 0) {
          const errorMsg = ( 
            <div>
              <h4 className='server-heading'>
                Switch Offline
              </h4>
              <p>
                Switch <span className='highlight-text'>{currSwitch.switch_id}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> has gone offline.            
              </p>
              <div className="refer-container">
                <button className="refer-table-btn" onClick={() => scrollToAlertsTable('switches')}>
                  View Switch Alerts Table <i className="fas fa-external-link"></i>
                </button>
              </div>
            </div>
          );
          playSound(offlineAudio, '/sounds/offline.mp3');
          toast.error(errorMsg, {
            autoClose: 20000,
          });
        }
        if (prevSwitch.switch_status === 0 && currSwitch.switch_status === 1) {
          const successMsg = ( 
            <div>
              <h4 className='server-heading'>
                Switch Online
              </h4>
              <p>
                Switch <span className='highlight-text'>{currSwitch.switch_id}</span> attached to Server <span className='highlight-text'>{currServer.serverName}</span> is back online.            
              </p>
            </div>
          );
          playSound(onlineAudio, '/sounds/online.mp3');
          toast.success(successMsg, {
            autoClose: 10000,
          });
        }
      }
      
    });

    // 3. Save current state for next refresh
    serversPrevState.current = servers;

  }, [servers, toast, playSound]);

  //                                            ** ANALYTICS ALERT(s) **
  const analyticsPrevState = useRef([]);

  useEffect(() => {
    const analyticsPrev = analyticsPrevState.current;

    // 1. Skip on first render
    if (!analyticsPrev || analyticsPrev.length === 0) {
      analyticsPrevState.current = analytics;
      return;
    }

    // Convert previous array to a lookup map: { [hwid]: analytics }
    const analyticsPrevMap = Object.fromEntries(analyticsPrev.map(a => [a.hwid, a]));

    // For each current analytic, compare its current analyticAlertData with its previous status
    analytics.forEach(currSiteAnalytics => {
      // Get the previous analytic based on hwid
      const prevSiteAnalytics = analyticsPrevMap[currSiteAnalytics.hwid];

      // If it's a completely new site analytics
      if (!prevSiteAnalytics) {
        return; // skip to the next site analytics
      }

      // console.log(`Line 367 the current online analytics ${JSON.stringify(currSiteAnalytics.onlineAnalytics, null, 2)}`);
      const getKey = (a) => `${a.application}-${a.camera_id}`; 

      // Convert arrays to lookup maps: { [application + camera_id]: offlineAnalytic }
      const prevOfflineAnalyticsMap = Object.fromEntries(prevSiteAnalytics.analyticAlertData.map(a => [getKey(a), a]));
      const currOfflineAnalyticsMap = Object.fromEntries(currSiteAnalytics.analyticAlertData.map(a => [getKey(a), a]));

      // Filter out current offline analytics that don't exist in previous offline analytics, meaning new Offline analytics
      const newlyOffline = currSiteAnalytics.analyticAlertData.filter(offAnalytic => !prevOfflineAnalyticsMap[getKey(offAnalytic)]);

      // Filter out prev offline analytics that don't exist in current offline analytics, meaning these analytics are back Online
      const backOnline = prevSiteAnalytics.analyticAlertData.filter(offAnalytic => !currOfflineAnalyticsMap[getKey(offAnalytic)]);

      // Pop up toasts for newly offline analytics
      newlyOffline.forEach(a => {
        const errorMsg = ( 
          <div>
            <h4 className='server-heading'>
              Analytic Offline
            </h4>
            <p>
              Analytic <span className='highlight-text'>{a.application}</span> attached to Site <span className='highlight-text'>{currSiteAnalytics.site}</span> has gone offline.            
            </p>
            <div className="refer-container">
              <button className="refer-table-btn" onClick={() => scrollToAlertsTable('analytics')}>
                View Analytic Alerts Table <i className="fas fa-external-link"></i>
              </button>
            </div>
          </div>
        );
        playSound(offlineAudio, '/sounds/offline.mp3');
        toast.error(errorMsg, {
            autoClose: 20000,
        });
      });

      // Pop up toasts for back to online analytics
      backOnline.forEach(a => {
        const successMsg = ( 
          <div>
            <h4 className='server-heading'>
              Analytic Online
            </h4>
            <p>
              Analytic <span className='highlight-text'>{a.application}</span> attached to Site <span className='highlight-text'>{currSiteAnalytics.site}</span> is back online.            
            </p>
          </div>
        );
        playSound(onlineAudio, '/sounds/online.mp3');
        toast.success(successMsg, {
          autoClose: 10000,
        });
      });
    })

    // 3. Save current state for next refresh
    analyticsPrevState.current = analytics;

  }, [analytics, toast, playSound]);


  // Reset the previous servers and analytics state to empty on business change
  useEffect(() => {
    serversPrevState.current = [];
    analyticsPrevState.current = [];
  }, [selectedBusiness])

  // check if analytics data has any new edge pushed data
  function hasAnyEdgePushedAnalytics(analytics) {
  return analytics?.some(site => 
    (site.onlineAnalytics || []).some(item => item.camera_id !== null) ||
    (site.analyticAlertData || []).some(item => item.camera_id !== null)
  );
}

  // Filter servers data based on the sortedSites. If no match, return entire servers since the user isn't technician
  const filteredServers = useMemo(() => {
  const result = servers.filter(obj => sortedSites?.includes(obj.site));  
  return result.length > 0 ? result : servers;
  }, [servers, sortedSites]);

  servers = filteredServers;
  
  if (!sortedSites.includes('All')) {
      sortedSites.unshift('All');
  }

  const orangeIcon = new Icon({
    iconUrl: '/markerIcons/marker-icon-orange.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  const greenIcon = new Icon({
    iconUrl: '/markerIcons/marker-icon-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

 
  const redIcon = new Icon({
    iconUrl: '/markerIcons/marker-icon-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  
/** calculates the average latitude & longitude of all sites */
const calculateMapCenter = useCallback(() => {
  if (selectedSite && selectedSite.latitude && selectedSite.longitude) {
    // Center on the single selected site
    return [selectedSite.latitude, selectedSite.longitude];
  }

  // Otherwise calculate average of all servers
  let sumLatitude = 0, sumLongitude = 0;
  let count = 0;

  servers.forEach(site => {
    if (
      site.latitude &&
      site.longitude &&
      !isNaN(site.latitude) &&
      !isNaN(site.longitude)
    ) {
      sumLatitude += site.latitude;
      sumLongitude += site.longitude;
      count++;
    }
  });

  if (count === 0) return [0, 0]; // fallback center

  return [sumLatitude / count, sumLongitude / count];
}, [selectedSite, servers]);

/** re-centers and re-zooms the map to show all pins */
const recenterMap = useCallback(() => {
  if (!mapRef.current) return;

  const newCenter = calculateMapCenter();

  setCenter(newCenter);

  mapRef.current.panTo(new LatLng(newCenter[0], newCenter[1]));

  const bounds = new LatLngBounds();

  servers.forEach(site => {
    if (
      site.latitude !== null &&
      site.longitude !== null &&
      site.latitude &&
      site.longitude &&
      !isNaN(site.latitude) &&
      !isNaN(site.longitude)
    ) {
      bounds.extend([site.latitude, site.longitude]);
    }
  });

  if (bounds.isValid()) {
    mapRef.current.fitBounds(bounds);
  }
}, [servers, calculateMapCenter]);

  // past week offline servers modal
  const handleClosePastWkOfflineServer = () => {
    setShowPastWkOfflineServer(false);
  }
  
  const handleShowPastWkOfflineServer = () => {
    setShowPastWkOfflineServer(true);
  }
  
  // past week offline cameras modal
  const handleClosePastWkOfflineDevices = () => {
    setShowPastWkOfflineDevices(false);
  }
  
  const handleShowPastWkOfflineDevices = () => {
    setShowPastWkOfflineDevices(true);
  }

  // unacknowledged alerts modal
  const handleCloseUnAckAlerts = () => {
    setShowUnAckAlerts(false);
  }

  const handleShowUnAckAlerts = () => {
    // toast.error('Show unk alerts', {autoClose: 5000, hideProgressBar: true});
    setShowUnAckAlerts(true);
  }

  const handleOpenPortLayout = () => {
    setIsPortLayoutVisible(true);
    toast.dismiss();
  }

  const handleClosePortLayout = () => {
    setIsPortLayoutVisible(false);
    toast.dismiss();
  }

  // Fetch matterport model id given hwid from backedn fetch call
  const fetchMatterportModelId = async(hwid) => {
    try {
      const response = await API.get(`/matterport/model-id/${encodeURIComponent(hwid)}`);
      if (response.status === 200) {
        const data = response.data;
        return data.modelId; // assuming the response contains { modelId: '...' }
      } else {
        console.error(`Failed to fetch Matterport model ID. Status: ${response.status}`);
        return null;
      }
    } catch (error) {
      console.error('Error fetching Matterport model ID:', error);
      return null;
    }
  }

  // Open the site plan type mode selection (Matterport vs General 2D) per pin click and dispatch the list of associated cameras for that site
  const handleOpenSitePlan = (business, site, servers) => {
    const hwid = servers[0]?.hwid;
    setHwid(hwid);
    setShowSitePlanTypeModal(true);  
    setPinSiteName(site);

     if (hwid) {
      dispatch(listDevicesPerSite({hwid: hwid}));
    }  
  }

  // set Matterport tags given matterport model id
  const setMatterportTags = async(matterPortModelId) => {
  try {
    // fetch matterport tags tied matterport model id form backend api
    const response = await API.get(`/matterport/tags/${encodeURIComponent(matterPortModelId)}`);
    if (response.status === 200) {
      const data = response.data;
      // Assuming the response contains { tags: [...] }
      const tags = data.tags;
      setTags(tags);
    }
  } catch (error) {
    console.error('Error fetching Matterport tags:', error);
  }
}

const handleMappterportEditTag = () => {
  setShowMatterportModelEdit(true);
}

const handleMappterportUnmapWarningModal = () => {
  setShowMatterportUnmapWarning(true);
}

// Unmap the selected Model from the mapped site
const handleMappterportUnmap = async() => {
  try {
    const payload = {
        hwid: hwid,
        modelId: selectedMatterPortModelId,
        siteName: pinSiteName
      };
    const response = await API.post('/matterport/model-site-unmapping', payload);
    if (response.status === 200) {
      const successMsg = response.data.message || `Successfully unmapped Matterport model - ${selectedMatterPortModelId} from site - ${pinSiteName}`;
      toast.success(successMsg, { autoClose: 5000 });
      setShowMatterportModal(false);
      setShowMatterportUnmapWarning(false);
      setSelectedMatterportModelId('');
      setTags([]);
    } else {
      const errorMsg = response.data.message || 'Failed to unmap Matterport model from site';
      toast.error(errorMsg, { autoClose: 5000 });
    }
  } catch (error) {
    console.error('Error unmapping Matterport model from site:', error);
    toast.error(`An error occurred while unmapping the Matterport model from site ${pinSiteName}`, { autoClose: 5000 });
  }
}


  useEffect(() => {
    if (hwid) {
      dispatch(listDevicesPerSite({hwid: hwid}));
    }
  }, [hwid, dispatch]);

  // test only
  useEffect(() => {
    if (hwid) {
      dispatch(listPlacedCamPositions(hwid));
    }
  }, [hwid, dispatch]);

  const handleCloseSitePlan = () => {
    setIs2DSitePlanVisible(false);
  }

  // Alert data
  const serversAlert = servers?.filter((row) => row.devicesOffline !== 0 || row.serverStatus === 'Offline');

  // Healthy data
  const serversHealthy = servers?.filter((row) => row.devicesOffline === 0 && row.serverStatus === 'Online');

  // Healthy analytics toggle
  const toggleHealthyAnalyticsTableVisibility = () => {
    setIsHealthyAnalyticsTableVisible(prevState => !prevState);
  };

  // Healthy UPS toggle
  const toggleHealthyUPSTableVisibility = () => {
    setIsHealthyUPSTableVisible(prevState => !prevState);
  };

  // Healthy Switches toggle
  const toggleHealthySwitchesTableVisibility = () => {
    setIsHealthySwitchesTableVisible(prevState => !prevState);
  };

  // Healthy data toggle
  const toggleHealthTableVisibility = () => {
    setIsHealthTableVisible(prevState => !prevState);
  };

  // Storage data toggle
  const toggleStorageTableVisibility = () => {
    setIsStorageTableVisible(prevState => !prevState);
  };

  // Additional Info data toggle
  // const toggleInfoTableVisibility = () => {
  //   setIsInfoTableVisible(prevState => !prevState);
  // };

  // filter data based on business - total
  const handleBusinessChange = (event) => {
    setSelectedBusiness(event.target.value);

    // store in local storage
    localStorage.setItem('selectedBusiness', event.target.value);
    localStorage.setItem('noServersData', 'false');

    setSelectedSite('All');
    setSelectedServer(null);
    setSelectedSI('');

    setHighlightedTable(null);

    dispatch(fetchSelectedBusiness(event.target.value));
  };

  let businessNames = businesses?.map(business => Object.keys(business)[0]);  

  // unique business names
  businessNames = businessNames?.sort();  

  // rest selected business in local stroate if its value is not found in businessNames list
  useEffect(() => {
    const storedBusiness = localStorage.getItem('selectedBusiness');
    if (storedBusiness && businessNames?.includes(storedBusiness)) {
      setSelectedBusiness(storedBusiness);
    } else if (businessNames?.length > 0) {
      setSelectedBusiness(businessNames[0]);
      localStorage.setItem('selectedBusiness', businessNames[0]);
    }
  }, [businessNames]);

  const filteredDataBusiness = useMemo(() => {
    return selectedBusiness === 'All'
    ? servers
    : servers.filter((row) => row.business === selectedBusiness);
  }, [servers, selectedBusiness]);

  const filteredDataGroup = useMemo(() => {
  // If no grouping or "All Groups" selected, return business filtered data
  if (!isGroupingActive || selectedGroup === 'all') {
    return filteredDataBusiness;
  }
  
  // If specific group selected, filter to only sites in that group
  const selectedGroupObj = siteGroups.find(g => g && g.id && g.id.toString() === selectedGroup);
  
  if (!selectedGroupObj || !selectedGroupObj.sites) {
    return filteredDataBusiness;
  }
  
  const sitesInGroup = selectedGroupObj.sites.map(s => s.site_name);
  
  return filteredDataBusiness.filter((row) => 
    sitesInGroup.includes(row.site)
  );
}, [filteredDataBusiness, isGroupingActive, selectedGroup, siteGroups]);

// Step 3: Filter by Site (updated to use filteredDataGroup)
const filteredDataSite = useMemo(() => {
  return selectedSite === 'All'
    ? filteredDataGroup
    : filteredDataGroup.filter((row) => row.site === selectedSite);
}, [filteredDataGroup, selectedSite]);
  
  // Alert data - all types
  const filteredDataBusinessAlert =
    selectedBusiness === 'All'
      ? serversAlert
      : serversAlert.filter((row) => row.business === selectedBusiness);
  
  // Healthy data
  const filteredDataBusinessHealthy =
    selectedBusiness === 'All'
      ? serversHealthy
      : serversHealthy.filter((row) => row.business === selectedBusiness);

  // returns SI name given site name
  const getSIfromSite = (site) => {
    for (const server of servers) {
      if (server.site === site) {
        return server.si;
      }
    }
    return '';
  }
  


  // filter data based on VMS
  const handleVMSChange = (event) => {
    setSelectedVMS(event.target.value);
  };

  // Total data
  // const filteredDataSite =
  // selectedSite === 'All'
  //   ? filteredDataBusiness
  //   : filteredDataBusiness.filter((row) =>
  //       row.site === selectedSite
  //     );

  // Get unique VMS types from the filtered data based on selected business and site
  const uniqueVMSTypes = ['All', ...new Set(filteredDataSite.map((row) => row.vms_type))].sort();

  // Further filter data based on selected VMS type
  const finalFilteredDataSite =
  selectedVMS === 'All'
    ? filteredDataSite
    : filteredDataSite.filter((row) => row.vms_type === selectedVMS);      
  
  // past week offline devices
  const pastWeekOfflineDevices = () => {
    let totalPastWkOfflineDevices = [];
    for (let i = 0; i < finalFilteredDataSite.length; i++) {
      let eachServerData = [];

      eachServerData = finalFilteredDataSite[i].devicesOfflinePastWeek;
      
      if (eachServerData) {
        for (let j = 0; j < eachServerData.length; j++) {
          totalPastWkOfflineDevices.push({
            serverName: eachServerData[j].serverName,
            cameraName: eachServerData[j].cameraName,
            site: eachServerData[j].site
          })
      }
    }  
  }
  return totalPastWkOfflineDevices;
}

  // Alert data - all types
  // Filter by group (if grouping is active)
const filteredDataGroupAlert = useMemo(() => {
  // If no grouping or "All Groups" selected, skip group filtering
  if (!isGroupingActive || selectedGroup === 'all') {
    return filteredDataBusinessAlert;
  }
  
  // If specific group selected, show only sites in that group
  const selectedGroupObj = siteGroups.find(g => g && g.id && g.id.toString() === selectedGroup);
  
  if (!selectedGroupObj || !selectedGroupObj.sites) {
    return filteredDataBusinessAlert;
  }
  
  const sitesInGroup = selectedGroupObj.sites.map(s => s.site_name);
  
  return filteredDataBusinessAlert.filter((row) => 
    sitesInGroup.includes(row.site)
  );
}, [filteredDataBusinessAlert, isGroupingActive, selectedGroup, siteGroups]);

// Filter by site
const filteredDataSiteAlert = useMemo(() => {
  if (selectedSite === 'All') {
    return filteredDataGroupAlert;
  }
  
  return filteredDataGroupAlert.filter((row) => 
    row.site === selectedSite
  );
}, [filteredDataGroupAlert, selectedSite]);

  // const filteredDataSiteAlert =
  // selectedSite === 'All'
  //   ? filteredDataBusinessAlert
  //   : filteredDataBusinessAlert.filter((row) => 
  //       row.site === selectedSite
  //     );

  // final alert data based on VMS type
  const finalFilteredDataSiteAlert =
  selectedVMS === 'All'
    ? filteredDataSiteAlert
    : filteredDataSiteAlert.filter((row) => row.vms_type === selectedVMS);


  // Healthy data
  const filteredDataSiteHealthy =
  selectedSite === 'All'
    ? filteredDataBusinessHealthy
    : filteredDataBusinessHealthy.filter((row) => 
        row.site === selectedSite
      );

  // final healthy data based on VMS type
  const finalFilteredDataSiteHealthy =
  selectedVMS === 'All'
    ? filteredDataSiteHealthy
    : filteredDataSiteHealthy.filter((row) => row.vms_type === selectedVMS);

  // sort by devices - total data
  const sortedData = [...finalFilteredDataSite].sort((a, b) => b.devicesOffline - a.devicesOffline);
  
  // check if at least one storage status is offline
  const alertStorage = () => {
    if (sortedData.length) {
      for (const eachServer of sortedData) {    
        if (eachServer?.storage?.length) {
          for (const eachStorage of eachServer?.storage) { 
            if (eachStorage.storageStatus !== 'Online') {
              return true;
            }
          }          
        }    
      }
    }
    return false;   
  }

  // check if at least one additional device status is offline
  const alertAdditionalDevices = () => {   
    if (sortedData.length) {
      for (const eachServer of sortedData) {
        if (eachServer?.additionalInfo?.length) {
          for (const eachAdditionalInfo of eachServer?.additionalInfo) {       
            if (eachAdditionalInfo.info_status !== 'Online') {
              return true;
            }
          }          
        }
      }
    }
    return false;   
  }
  // group servers data by site
  function groupBySite(data) {
    return Object.entries(data.reduce((acc, current) => {
      const { business, site, hwid, serverName, serverStatus, serverOfflineSince, totalDevices, devicesOffline, latitude, longitude } = current;
  
      if (!acc[site]) {
        acc[site] = [];
      }
  
      acc[site].push({
        business,
        hwid,
        serverName,
        serverStatus,
        serverOfflineSince,
        totalDevices,
        devicesOffline,
        latitude,
        longitude
      });
  
      return acc;
    }, {})).map(([site, servers]) => ({ site, servers }));
  }

  // sort by devices - alert data (offline)
  const sortedDataAlerts = [...finalFilteredDataSiteAlert].sort((a, b) => b.devicesOffline - a.devicesOffline);

  // filter unacknowledged alerts
  const unAckAlerts = sortedDataAlerts.filter((server) => !server.serverAckStatus);  

  // sort by devices - healthy  data
  const sortedDataHealthy = [...finalFilteredDataSiteHealthy].sort((a, b) => b.devicesOnline - a.devicesOnline);

  // sort by all columns - healthy data
  const sortedAllColumnsHealthy = [...sortedDataHealthy].sort((a, b) => {
    if (a[sortConfigHealthy.key] < b[sortConfigHealthy.key]) {
      return sortConfigHealthy.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfigHealthy.key] > b[sortConfigHealthy.key]) {
      return sortConfigHealthy.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  // sort by all columns - alert data
  const sortedAllColumnsAlerts = [...sortedDataAlerts].sort((a, b) => {
    if (a[sortConfigAlerts.key] < b[sortConfigAlerts.key]) {
      return sortConfigAlerts.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfigAlerts.key] > b[sortConfigAlerts.key]) {
      return sortConfigAlerts.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });


  const renderSortIconHealthy = (columnKey) => {
    if (sortConfigHealthy.key === columnKey) {
      return sortConfigHealthy.direction === 'ascending' ? '▲' : '▼';
    }
    // Default to ascending arrow if not sorted yet
    return '▲';
  };

  const renderSortIconAlert = (columnKey) => {
    if (sortConfigAlerts.key === columnKey) {
      return sortConfigAlerts.direction === 'ascending' ? '▲' : '▼';
    }
    // Default to ascending arrow if not sorted yet
    return '▲';
  };

  // handle leaflet Marker color
  function addColorField(siteData) {
    return siteData.map(site => {
      const offlineServers = site.servers.some(server => server.serverStatus === 'Offline');
      const hasOfflineDevices = site.servers.some(server => server.devicesOffline > 0);
  
      let color;
      if (offlineServers) {
        color = 'red';
      } else if (hasOfflineDevices) {
        color = 'orange';
      } else {
        color = 'green';
      }
  
      return {
        ...site,
        color
      };
    });
  }

  const filteredDataBySite = groupBySite(finalFilteredDataSite);
  const filteredDataBySiteWithColor = addColorField(filteredDataBySite);

  // Sort the filteredDataBySiteWithColor array based on the color
  const sortedDataByColor = [...filteredDataBySiteWithColor].sort((a, b) => {
    // Define the order of colors: red > orange > green
    const colorOrder = { "red": 3, "orange": 2, "green": 1 };

    // Get the order of colors for each site
    const colorOrderA = colorOrder[a.color];
    const colorOrderB = colorOrder[b.color];

    // Sort based on the color order
    return colorOrderA - colorOrderB;
  });

  // past week offline servers
  const pastWeekOfflineServers = sortedData.filter((server) => server.serverOfflinePastWeekStatus === true);  
 
  // Chart count data - > Servers
  const totalServers = sortedData.length;
  const offlineServers = sortedData.filter(server => server.serverStatus === 'Offline');
  const totalOfflineServers = offlineServers.length;
  const onlineServers = sortedData.filter(server => server.serverStatus === 'Online');
  const totalOnlineServers = onlineServers.length;

  // Chart count data - > Devices
  const totalOfflineDevices = finalFilteredDataSite.reduce((sum, server) => sum + server.devicesOffline, 0);
  const totalDevices = finalFilteredDataSite.reduce((sum, server) => sum + server.totalDevices, 0);
  const totalOnlineDevices = totalDevices - totalOfflineDevices;

  // Chart count data - > UPS
  // for each server, accumulate total of additional devices
  const totalUPS = finalFilteredDataSite.reduce((sum, server) => sum + server.additionalInfo.length, 0);
  // count number of offline UPS
  let totalOfflineUPS = 0;
  if (finalFilteredDataSite) {
    for (const server of finalFilteredDataSite) {
      for (const additionalDevice of server?.additionalInfo){
        if (additionalDevice?.info_status === 'Offline') {
          totalOfflineUPS ++;
        }
      }
    } 
  }

  const totalOnlineUPS = totalUPS - totalOfflineUPS;

  // Chart count data - > Analytics  
  let totalAnalytics = 0;
  let totalOfflineAnalytics = 0;

  const uniqueSites = [...new Set(finalFilteredDataSite.map(server => server.site))];

  const sortedAnalytics = (analytics || [])
  .filter(a => uniqueSites.includes(a.site))
  .sort((a, b) => {
    const aOffline = a.analyticAlertData?.length || 0;
    const bOffline = b.analyticAlertData?.length || 0;
    return bOffline - aOffline;
  });
  

  for (const site of uniqueSites) {
    const matchingAnalytics = analytics.find(a => a.site === site);

    const analyticAlertLength = matchingAnalytics?.analyticAlertData?.length || 0;
    const totalApplicationsServer = matchingAnalytics?.totalApplications || 0;

    totalAnalytics += totalApplicationsServer;
    totalOfflineAnalytics += analyticAlertLength;
  }

const totalOnlineAnalytics = totalAnalytics - totalOfflineAnalytics;

  // Chart count data - > Switches
  let totalSwitches = 0;
  let totalOfflineSwitches = 0;
  let totalPortsAllSwitches = 0;

  for (const server of finalFilteredDataSite){
    // If connected_ports is not empty, there is a switch connected to the server
    if (server.switchInfo !== null){
      totalSwitches++;
      if (server.switchInfo.switch_status === 0) {
        totalOfflineSwitches++;
      }
      else if (server.switchInfo.switch_status === 1) {
        totalPortsAllSwitches = totalPortsAllSwitches + server.switchInfo.total_ports;
      }
    }
  }

  let totalOnlineSwitches = totalSwitches - totalOfflineSwitches;

  // Display donuts
  const chartServersData = totalServers ? 
  {
    labels: [`Online servers`, 'Offline servers'],
    datasets: [
      {
        data: [totalOnlineServers, totalOfflineServers],
        backgroundColor: ['#D0BCFE', '#C82333'],
        borderRadius: totalOnlineServers === 0 || totalOfflineServers === 0 
        ? { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 }
        : [
            { outerStart: 5, outerEnd: 0, innerStart: 5, innerEnd: 0 }, // First segment
            { outerStart: 0, outerEnd: 5, innerStart: 0, innerEnd: 5 }  // Second segment
          ],
      },
    ],
  }
  : 
  {
    labels: ['No Data Available'],
    datasets: [
      {
        data: [1],
        backgroundColor: ['#909090'],
        borderRadius: [
          { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 },
        ],
      },
    ],
  }
  ;

  const chartDevicesData =  totalDevices ? 
  { 
    labels: ['Online cameras', 'Offline cameras'],
    datasets: [
      {
        data: [totalOnlineDevices, totalOfflineDevices],
        backgroundColor: ['#4D519E', '#C82333'],
        borderRadius: totalOnlineDevices === 0 || totalOfflineDevices === 0 
        ? { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 }
        : [
            { outerStart: 5, outerEnd: 0, innerStart: 5, innerEnd: 0 },
            { outerStart: 0, outerEnd: 5, innerStart: 0, innerEnd: 5 } 
          ],
      },
    ],
  }
  :
  {
    labels: ['No Data Available'],
    datasets: [
      {
        data: [1],
        backgroundColor: ['#909090'],
        borderRadius: [
          { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 },
        ],
      },
    ],
  }
  ;

  const chartAnalyticsData = totalAnalytics ?
  {
    labels: ['Online analytics', 'Offline analytics'],
    datasets: [
      {
        data: [totalOnlineAnalytics, totalOfflineAnalytics],
        backgroundColor: ['#31BDFF', '#C82333'],
        borderRadius: totalOnlineAnalytics === 0 || totalOfflineAnalytics === 0 
        ? { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 }
        : [
            { outerStart: 5, outerEnd: 0, innerStart: 5, innerEnd: 0 },
            { outerStart: 0, outerEnd: 5, innerStart: 0, innerEnd: 5 }
          ],
      },
    ],
  }
  :
  {
    labels: ['No Data Available'],
    datasets: [
      {
        data: [1],
        backgroundColor: ['#909090'],
        opacity: 0.8,
        borderRadius: [
          { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 },
        ],
      },
    ],
  }
  ;

  const chartSwitchesData = totalSwitches ?
  {
    labels: ['Online switches', 'Offline switches'],
    datasets: [
      {
        data: [totalOnlineSwitches, totalOfflineSwitches],
        backgroundColor: ['#72DCFF', '#C82333'],
        borderRadius: totalOnlineSwitches === 0 || totalOfflineSwitches === 0 
        ? { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 }
        : [
            { outerStart: 5, outerEnd: 0, innerStart: 5, innerEnd: 0 },
            { outerStart: 0, outerEnd: 5, innerStart: 0, innerEnd: 5 }
          ],
      },
    ],
  }
  :
  {
    labels: ['No Data Available'],
    datasets: [
      {
        data: [1],
        backgroundColor: ['#909090'],
        borderRadius: [
          { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 },
        ],
      },
    ],
  }
  ;

  const chartUPSData = totalUPS ? {
    labels: ['Online UPS', 'Offline UPS'],
    datasets: [
      {
        data: [totalOnlineUPS, totalOfflineUPS],
        backgroundColor: ['#6161D8', '#C82333'],
        borderRadius: totalOnlineUPS === 0 || totalOfflineUPS === 0 
        ? { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 }
        : [
            { outerStart: 5, outerEnd: 0, innerStart: 5, innerEnd: 0 },
            { outerStart: 0, outerEnd: 5, innerStart: 0, innerEnd: 5 }
          ],
      },
    ],
  }
  :
  {
    labels: ['No Data Available'],
    datasets: [
      {
        data: [1],
        backgroundColor: ['#909090'],
        borderRadius: [
          { outerStart: 5, outerEnd: 5, innerStart: 5, innerEnd: 5 },
        ],
      },
    ],
  }
  ;

  const chartData = {
    servers: chartServersData,
    totalOfflineServers: totalOfflineServers,
    totalOnlineServers: totalOnlineServers,
    devices: chartDevicesData,
    totalOnlineDevices: totalOnlineDevices,
    totalOfflineDevices: totalOfflineDevices,
    analytics: chartAnalyticsData,
    totalOfflineAnalytics: totalOfflineAnalytics,
    totalOnlineAnalytics: totalOnlineAnalytics,
    switches: chartSwitchesData,
    totalOfflineSwitches: totalOfflineSwitches,
    totalOnlineSwitches: totalOnlineSwitches,
    ups: chartUPSData,
    totalOfflineUPS: totalOfflineUPS,
    totalOnlineUPS: totalOnlineUPS
  }

  useEffect(() => {
    var timer = setInterval(()=>setDate(new Date()), 1000 )
    return function cleanup() {
        clearInterval(timer)
    }
  });

  useEffect(() => {   
    if (user && selectedBusiness) {
      dispatch(listServers({user, selectedBusiness}));
      dispatch(businessTokenMapping({user: user}));
    }
   
  }, [dispatch, user, selectedBusiness]);

  useEffect(() => {
    if (serversResponsecode === 200 && initialLoad) {    
      setInitialLoad(false);
    }
  }, [serversResponsecode, initialLoad]);
  
  // set no servers data state
// useEffect(() => { 
//   if (serversResponsecode === 200) {
//     if (servers.length === 0) {      
//         setNoServersData(true);
//         setInitialLoad(false);
//     }
//   }
// }, [servers, serversResponsecode, initialLoad]);

useEffect(() => {
  if (mapRef.current && mapRefLoaded && servers?.length > 0) {
    recenterMap();
  }
}, [servers, selectedSite, recenterMap, mapRefLoaded]);


  const isBusinessFound = servers.some(server => server.business === selectedBusiness);

  useEffect(() => {    
   if (serversResponsecode === 200 && isBusinessFound) {
    setLoadingSelectedBusiness(false);
   }
   else {
    setLoadingSelectedBusiness(true);
   }
  }, [selectedBusiness, serversResponsecode, isBusinessFound]);

  const utcStrToLocal = (utcTimestamp) => {
    // Create a Date object using the UTC timestamp
    const utcDate = new Date(utcTimestamp);

    // Get the local time components
    const localYear = utcDate.getFullYear();
    const localMonth = utcDate.getMonth() + 1; // Months are zero-based
    const localDay = utcDate.getDate();
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const localSeconds = utcDate.getSeconds();
    // Create a new Date object with the local time components
    const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);
    // Format the local time as needed
    const formattedLocalTime = localDate.toLocaleString();
    return formattedLocalTime
  }

  // // set first business as default selected
  useEffect(() => {
    if (businessNames?.length > 0 && !selectedBusiness) {
      setSelectedBusiness(businessNames[0]);
      dispatch(fetchSelectedBusiness(businessNames[0]));
    }      
  }, [selectedBusiness, businessNames, dispatch]);

  // get total number of storages and offline storages
  let totalStorages = 0;
  let totalOfflineStorages = 0;
  sortedData.forEach((server) => {
    totalStorages += server?.storage?.length;
    let server_storages = server?.storage;
    server_storages.forEach((storage) => {
      if (storage.storageStatus === 'Offline') {
        totalOfflineStorages ++;
      }
    })
  })

  useEffect(() => {
    const email = localStorage.getItem('email');
    dispatch(newFeature(email));
  }, [dispatch]);


function MapReadyHandler({ onMapReady }) {
  const map = useMap();

  useEffect(() => {
    if (map) {
      onMapReady(map);
    }
  }, [map, onMapReady]);

  return null;
}

// Check if the newly created business has no sites
useEffect(() => {
  if (fetchUserResponse?.businesses) {
    if (fetchUserResponse?.businesses.length === 1) {
    setBusinessNoSites(Object.values(fetchUserResponse?.businesses[0])[0]);
    }
  }
}, [fetchUserResponse]);

// Fetch RBAC business-roles
const fetchAndStoreRBAC = async (email) => {
  try {
    const url_path = url+'/fetch_rbac'; // Use environment variable or default to localhost
    const response = await fetch(url_path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ user: email })
    });
    
    const rbacResponse = await response.json();
    // console.log("RBAC fetched:", rbacResponse);

    // Store in localStorage for persistence
    localStorage.setItem('rbac_role', rbacResponse.global_role);
    localStorage.setItem('rbac_data', JSON.stringify(rbacResponse.business_roles));
    return rbacResponse;
  } catch (error) {
    console.error('Error fetching RBAC data:', error);
  }
};

// SINGLE useEffect for initialization
useEffect(() => {
  const email = localStorage.getItem('email');
  
  if (!email) {
    // window.location.href = '/';
    return;
  }

  const initializeData = async () => {
    try {
      // Fetch RBAC data first
      await fetchAndStoreRBAC(email);
        
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
    }
  };

  initializeData();
}, []); // Empty dependency array - run once only

// Remove servers with duplicate UPS
const removeServerWithDuplicateUPS = (data) => {
  const uniqueServers = data.filter((server, index, self) => {
  const currentInfo = JSON.stringify(server.additionalInfo || []);
    return index === self.findIndex(s => JSON.stringify(s.additionalInfo || []) === currentInfo);
  });

  return uniqueServers;
}

  const [selectedServer, setSelectedServer] = useState(null);   
  const [selectedServerName, setSelectedServerName] = useState('');  
  const [show, setShow] = useState(false);
  const [showNinjaModal, setShowNinjaModal] = useState(false);
  const [ack, setAck] = useState(selectedServer?.serverAckData?.serverAckStatus);
  const [showAckWarning, setShowAckWarning] = useState(false);

  const handleAckWarningClose = () => setShowAckWarning(false);
  const handleAckWarningShow = (server) => {
    setShowAckWarning(true);
    setAck(false);
    setSelectedServer(server);
    setAckNote('');
  } 
  const handleNinjaModalClose = () => {
    setShowNinjaModal(false);
    setSelectedServer(null);
  }
  const handleNinjaModalShow = (server) => {
    setShowNinjaModal(true);
    setSelectedServer(server);
  }

  const handleClose = () => {
    setShow(false);
    setSelectedServerName('');
    // setSelectedServer(null);
  } 

  const handleShow = (serverName, server) => {
    setSelectedServerName(serverName);
    setSelectedServer(server);
    setShow(true);
  }

  // Utility to format date as MM/DD/YYYY HH:MM:SS
  const getFormattedTime = () => {
    const now = new Date();
    return now.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }) + 
          ' ' + 
          now.toLocaleTimeString('en-US', { hour12: false });
  };

  const handleACK = async (serverName) => {
    if (ack) {
      alert("This fault has already been acknowledged.");
      return;
    }
  
    try {
      // if no ack commnet entered
      if (!ackNote || ackNote.trim() === '') {
        alert("Please enter an acknowledgment note before proceeding.");
        return;
      }
      const hwid = selectedServer.hwid || 'N/A'; // Fallback to 'N/A' if hwid is not available
      const ackData = { serverName, user, hwid, ackNote };
  
      const response = await API.post('/ack', ackData); // 👈 Using your API instance
  
      handleAckWarningClose(); // Close the modal after acknowledgment
  
      if (response.data?.msg === 200) {
        const successMsg = "Fault successfully acknowledged.";     
          toast.success(successMsg, {
            autoClose: 9000
          });
  
        // Dynamically update server data
        selectedServer.serverAckData.ackBy = user;
        selectedServer.serverAckData.ackTime = getFormattedTime();
        selectedServer.serverAckData.ackMode = "portal";
        selectedServer.serverAckData.ackNote = ackNote;
  
        setAck(true); // React state triggers re-render
      } else {
        alert("Internal server error. Please try again later.");
      }
    } catch (error) {
      console.error(error);
      alert("Internal server error. Please try again later.");
    }
  };

    // read ack note
  const handleAckNoteChange = (e) => {
    const text = e.target.value;

    if (text.length <= MAX_LENGTH) {
      setAckNote(text);
    }
  };

  // calculate total days since the give date time given have passed
  const daysSince = (targetDateStr) => {
    //const targetDate = parseCustomDateFormat(targetDateStr);    
    // Get the current local date and time
    let currentDate = new Date().toISOString();
    
    // Parse the date strings into Date objects
    currentDate = new Date(currentDate);
    let targetDate = new Date(targetDateStr);    

    // Calculate the time difference in milliseconds
    const timeDifference = currentDate - targetDate;     
   
    // Convert milliseconds to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);    
    return Math.floor(daysDifference);
  }

function convertUtcToLocal(utcTime) {
  if (!utcTime) return "";
  const date = new Date(utcTime);
  // Format: e.g. "Tuesday, November 12, 2025, 10:54 AM"
  return date.toLocaleString(undefined, {
    weekday: "long",   // e.g. Monday
    year: "numeric",   // e.g. 2025
    month: "long",     // e.g. November
    day: "numeric",    // e.g. 12
    hour: "2-digit",
    minute: "2-digit",
    hour12: true       // 12-hour format; set to false for 24-hour
  });
}

const dateTimeUTC = (datetime) => {
  let deviceOfflineSince = datetime;
  if (datetime !== 'N/A') {
      deviceOfflineSince = utcStrToLocal(datetime);
  }
  return deviceOfflineSince;
};

// Headers for server alerts table
const server_alerts_columns = [
  { key: 'site', label: 'Site', onClick: () => handleSortAlert('site'), icon: renderSortIconAlert('site') },
  { key: 'vms_type', label: 'VMS', onClick: () => handleSortAlert('vms_type'), icon: renderSortIconAlert('vms_type') },
  { key: 'serverName', label: 'Server', onClick: () => handleSortAlert('serverName'), icon: renderSortIconAlert('serverName') },
  { key: 'serverStatus', label: 'Status', onClick: () => handleSortAlert('serverStatus'), icon: renderSortIconAlert('serverStatus') },
  { key: 'serverOnlineDays', label: 'Activity Time', onClick: () => handleSortAlert('serverOnlineDays'), icon: renderSortIconAlert('serverOnlineDays') },
  { key: 'serverOfflineSince', label: 'Server Offline Since', onClick: () => handleSortAlert('serverOfflineSince'), icon: renderSortIconAlert('serverOfflineSince') },
  { key: 'totalDevices', label: 'Cameras - Total / Offline', onClick: () => handleSortAlert('totalDevices'), icon: renderSortIconAlert('totalDevices') },
  { key: 'ackStatus', label: 'Acknowledge Status' },
];

// Data for server alerts table
const server_alerts_data = sortedAllColumnsAlerts.map((server, index) => {

    let serverOfflineSince = server.serverOfflineSince;
    let isAlert = true;
    let isUnAck= false;

    // server offline activity
    let offlineDays = 0;
    if (server.serverOfflineSince !== 'N/A') {
        serverOfflineSince = utcStrToLocal(server.serverOfflineSince);
        offlineDays = daysSince(server.serverOfflineSince);
    }
    else {
      serverOfflineSince = '-'
    }
    // server online activity
    let onlineDays = 1;
    if (server.serverStatus === 'Online') {
      onlineDays = server.serverOnlineDays;
    }

    // server activity time
    let activityDays = 0;
    if (server.serverStatus === 'Online') {
      activityDays = onlineDays;
    } else {
      activityDays = offlineDays;
    }

    // calculate colors, activityDays etc. here
    const deviceColor = server.devicesOffline ? '#C82333' : '#22BE63';
    const serverColor = server.serverStatus === 'Online' ? '#22BE63' : '#C82333';
    const activityColor = server.serverStatus === 'Online' ? '#22BE63' : '#C82333';
    const ack = server.serverAckData?.ackBy;

    let vms_type = server.vms_type;

    if (vms_type === 'Milestone') {
      server.vms_logo = vms_milestone;
    } else if (vms_type === 'Nx Witness' || vms_type === 'Nx' || vms_type === 'nx') {
      server.vms_logo = vms_nx;
    }  else if (vms_type === 'Avigilon') {
      server.vms_logo = vms_avigilon;
    } else if (vms_type === 'Wisenet Wave') {
      server.vms_logo = vms_wisenet;
    } else if (vms_type === 'DW Spectrum') {    
      server.vms_logo = vms_dw;
    }
    else {
      server.vms_logo = null; // or a default image
    }

    return {
      site: (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{server.site}</span>
          <DeviceInfoIcon 
            onClick={() => handleNinjaModalShow(server)}
            disabled={!server.ninjaDetail?.ninjaData}
            server={server}
          />
        </div>
      ),
      vms_type: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
        {server.vms_logo && (
          <img
            src={server.vms_logo}
            alt={vms_type}
            title={vms_type}
            style={{ height: vms_type === 'Avigilon' ? '1.7em' :  '2em' }}
          />
        )}
        <span>{server.vms_type}</span>
      </div>
    ),
      serverName: server.serverName,
      serverStatus: <span style={{ color: serverColor, fontWeight: '600' }}>{server.serverStatus}</span>,
      serverOnlineDays: (
        <div style={{ display: 'flex', alignItems: 'center', fontWeight: '600' }}>
          {server.serverStatus === 'Online' ?
            <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
            </svg> :
            <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
               <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
          </svg>
          }
          <span style={{ color: activityColor, marginLeft: '.2rem' }}>{activityDays}d</span>
        </div>
      ),
      serverOfflineSince: serverOfflineSince,
      totalDevices: (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{server.totalDevices} / <span style={{ color: deviceColor, fontWeight: '600' }}>{server.devicesOffline}</span></span>
           <Button
            className='alert-table-camera-details-btn'
            disabled={!server.totalDevices}
            variant='dark'
            onClick={() => handleShow(server.serverName, server)}
          >
           <GenericTooltip content="Click to view camera details" placement="top">
             <FontAwesomeIcon icon={faVideoCamera} style={{ color: 'white' }}/>
              <span className='alert-table-camera-details-btn-text'>Details</span>
            </GenericTooltip>
          </Button>
        </span>
      ),
      ackStatus: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

        {!isUnAck ? (
            isAlert ? (               
              <>                  
              { ack ? 
                <GenericTooltip content={`Click to view acknowledgement detail`} placement="left">
                  <input type="checkbox" checked={true} style={{ cursor: 'pointer' }} onChange={ () => handleShowAckModal(server) }/>
                </GenericTooltip>
                : 
               <GenericTooltip content="Click the checkbox to acknowledge the fault" placement="top">
                 <div id='unack-chkbox-container'>
                <input type="checkbox" className="custom-checkbox" checked={ack} onChange={() => handleAckWarningShow(server)} />
                  <span style={{ marginLeft: '.4em' }}>Acknowledge</span>
                </div>
                </GenericTooltip>
              }
            </>
            ) : null
          ): null}   
      </div>
    ),
  }  
});

// Headers for healthy servers table
const servers_healthy_columns = [
  { key: 'site', label: 'Site', onClick: () => handleSortHealthy('site'), icon: renderSortIconHealthy('site')},
  { key: 'vms_type', label: 'VMS', onClick: () => handleSortHealthy('vms_type'), icon: renderSortIconHealthy('vms_type') },
  { key: 'serverName', label: 'Server', onClick: () => handleSortHealthy('serverName'), icon: renderSortIconHealthy('serverName') },
  { key: 'serverStatus', label: 'Status', onClick: () => handleSortHealthy('serverStatus'), icon: renderSortIconHealthy('serverStatus') },
  { key: 'serverOnlineDays', label: 'Activity Time', onClick: () => handleSortHealthy('serverOnlineDays'), icon: renderSortIconHealthy('serverOnlineDays') },
  { key: 'serverOfflineSince', label: 'Server Offline Since', onClick: () => handleSortHealthy('serverOfflineSince'), icon: renderSortIconHealthy('serverOfflineSince') },
  { key: 'totalDevices', label: 'Cameras - Total / Offline',  onClick: () => handleSortHealthy('totalDevices'), icon: renderSortIconHealthy('totalDevices') }
];

// Data for healthy servers table
const servers_healthy_data = sortedAllColumnsHealthy.map((server, index) => {
    let serverOfflineSince = server.serverOfflineSince;

    // server offline activity
    let offlineDays = 0;
    if (server.serverOfflineSince !== 'N/A') {
        serverOfflineSince = utcStrToLocal(server.serverOfflineSince);
        offlineDays = daysSince(server.serverOfflineSince);
    }
    else {
      serverOfflineSince = '-'
    }
    // server online activity
    let onlineDays = 1;
    if (server.serverStatus === 'Online') {
      onlineDays = server.serverOnlineDays;
    }

    // server activity time
    let activityDays = 0;
    if (server.serverStatus === 'Online') {
      activityDays = onlineDays;
    } else {
      activityDays = offlineDays;
    }

    // calculate colors, activityDays etc. here
    const deviceColor = server.devicesOffline ? '#C82333' : '#22BE63';
    const serverColor = server.serverStatus === 'Online' ? '#22BE63' : '#C82333';
    // const activityDays = server.serverOnlineDays;
    const activityColor = server.serverStatus === 'Online' ? '#22BE63' : '#C82333';

    let vms_type = server.vms_type;

    if (vms_type === 'Milestone') {
      server.vms_logo = vms_milestone;
    } else if (vms_type === 'Avigilon') {
      server.vms_logo = vms_avigilon;
    }
    else if (vms_type === 'Nx Witness' || vms_type === 'Nx' || vms_type === 'nx') {
      server.vms_logo = vms_nx;
    } else if (vms_type === 'Wisenet Wave') {
      server.vms_logo = vms_wisenet;
    } else if (vms_type === 'DW Spectrum') {    
      server.vms_logo = vms_dw;
    } 
    else {
      server.vms_logo = null; // or a default image
    }

  return ({
    site: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>{server.site}</span>
        <DeviceInfoIcon 
          onClick={() => handleNinjaModalShow(server)}
          disabled={!server.ninjaDetail?.ninjaData}
          server={server}
        />
      </div>
    ),
    vms_type: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
        {server.vms_logo && (
          <img
            src={server.vms_logo}
            alt={vms_type}
            title={vms_type}
            style={{ height: '2em' }}
          />
        )}
        <span>{server.vms_type}</span>
      </div>
    ),
    serverName: server.serverName,
    serverStatus: (
      <span style={{ color: serverColor, fontWeight: '600' }}>
        {server.serverStatus}
      </span>
    ),
    serverOnlineDays: (
      <div style={{ display: 'flex', alignItems: 'center', fontWeight: '600' }}>
        {server.serverStatus === 'Online' ?
          <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
          </svg> :
          <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
        </svg>
        }
        <span style={{ color: activityColor, marginLeft: '.2rem' }}>{activityDays}d</span>
      </div>
    ),
    serverOfflineSince: serverOfflineSince,
    totalDevices: (
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>{server.totalDevices} / <span style={{ color: deviceColor, fontWeight: '600'}}>{server.devicesOffline}</span></span>
         <Button
            className='healthy-table-camera-details-btn'
            disabled={!server.totalDevices}
            variant='dark'
            onClick={() => handleShow(server.serverName, server)}
          >
            <GenericTooltip
              content="Click to view camera details"
              placement='top'>
              <FontAwesomeIcon icon={faVideoCamera} style={{ color: 'white' }}/>
              <span className='healthy-table-camera-details-btn-text'>Details</span>
            </GenericTooltip>            
          </Button>
        
      </span>
    ),
  })
});

// Headers for analytic alerts table
const analytic_alerts_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'analyticName', label: 'Analytic Name' },
  ...(hasAnyEdgePushedAnalytics(analytics) 
    ? [{ key: 'cameraName', label: 'Camera Name' }] 
    : []),
  { key: 'analyticOnlineDays', label: 'Activity Time' },
  { key: 'analyticOfflineSince', label: 'Analytic Offline Since' },
  { key: 'analyticStatus', label: 'Analytic Status' }
];

// Data for analytic alerts table
const analytic_alerts_data = sortedAnalytics.flatMap((analytic, index) => {
  
  const siteName = analytic?.site;
  const analyticStatus =  analytic?.anayticStatus;

  const tooltipText = "Camera Name requires RONIN Agent update."

  return (
    analytic?.analyticAlertData?.map((analyticInfo, index) => (
      {
        site: siteName,
        analyticName: analyticInfo.application,
        ...(hasAnyEdgePushedAnalytics(analytics) && {
          cameraName: analyticInfo.camera_name ? (
             analyticInfo.camera_name
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                -
                <GenericTooltip content={tooltipText}>
                    <span className="custom-info-icon"><span>i</span></span>
                </GenericTooltip>
            </span>
          )
        })
        ,
        analyticOnlineDays: (
          <div style={{fontWeight: '600'}}>
            <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
            </svg>
            <span style={{ color: '#C82333', marginLeft: '.2rem' }}>{daysSince(analyticInfo.applicationOfflineSince)}d</span>
          </div>
        ),
        analyticOfflineSince: dateTimeUTC(analyticInfo.applicationOfflineSince),
        analyticStatus: (
          <span style={{ color: '#C82333', fontWeight: '600'}}>
              {analyticStatus}
          </span>
        )
      }
    ))
  ) 
});

// Headers for Analytic healthy table
const analytic_healthy_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'analyticName', label: 'Analytic Name' },
  ...(hasAnyEdgePushedAnalytics(analytics) 
    ? [{ key: 'cameraName', label: 'Camera Name' }] 
    : []),
  { key: 'analyticOnlineDays', label: 'Activity Time' },
  { key: 'analyticOfflineSince', label: 'Analytic Offline Since' },
  { key: 'analyticStatus', label: 'Analytic Status' },
];

// Data for Analytic healthy table
const analytic_healthy_data = sortedAnalytics.flatMap((analytic, index) => {
  
  const siteName = analytic?.site;
  const tooltipText = "Camera Name requires RONIN Agent update."

  return (
    analytic?.onlineAnalytics?.map((onlineAnalytic, index) => (
      {
        site: siteName,
        analyticName: onlineAnalytic.analytic_name,
        ...(hasAnyEdgePushedAnalytics(analytics) && {
          cameraName: onlineAnalytic.camera_name ? (
            onlineAnalytic.camera_name
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              -
              <GenericTooltip content={tooltipText}>
                <span className="custom-info-icon">i</span>
              </GenericTooltip>
            </span>
          )
        })
        ,
        analyticOnlineDays: (
          <div style={{fontWeight: '600'}}>
            <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
            </svg>
            <span style={{ color: '#22BE63', marginLeft: '.2rem' }}>{onlineAnalytic.analytic_online_days}d</span>
          </div>
        ),
        analyticOfflineSince: '-',
        analyticStatus: (
          <span style={{ color: '#22BE63', fontWeight: '600'}}>
            Online
          </span>
        )
      }
    ))
  ) 
});

const businessNamesWithSitesOptions = businessNames?.map((business, index) => (
  {
  label: business,
  value: business
  }
));

// Headers for UPS alerts table
const UPS_alerts_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'deviceType', label: 'Device Type' },
  { key: 'deviceLabel', label: 'Device Label' },
  { key: 'deviceOnlineDays', label: 'Activity Time' },
  { key: 'deviceOfflineSince', label: 'Device Offline Since' },
  { key: 'deviceStatus', label: 'Device Status' },
];

// Data for UPS alerts table
const UPS_alerts_data = sortedData.flatMap((server) => {
  return (
  (server?.additionalInfo || [])
    .filter(eachInfo => eachInfo.info_status === "Offline")
    .map(eachInfo => {
      return ({
        site: eachInfo.site,
        deviceType: eachInfo.info_type,
        deviceLabel: eachInfo.info_label,
        deviceOnlineDays: (
          <div style={{fontWeight: '600'}}>
            <svg
              style={{ color: '#C82333' }}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-down-right-circle"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"
              />
            </svg>
            <span style={{ color: '#C82333', marginLeft: '.2rem', fontWeight: '600' }}>
              {daysSince(eachInfo.UPSOfflineSince)}d
            </span>
          </div>
        ),
        deviceOfflineSince: dateTimeUTC(eachInfo.UPSOfflineSince),
        deviceStatus: (
          <span style={{ color: '#C82333', fontWeight: '600' }}>
            {eachInfo.info_status}
          </span>
        ),
      })
    })
  )}
);

// Headers for healthy UPS table
const UPS_healthy_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'deviceType', label: 'Device Type' },
  { key: 'deviceLabel', label: 'Device Label' },
  { key: 'deviceOnlineDays', label: 'Activity Time' },
  { key: 'deviceOfflineSince', label: 'Device Offline Since' },
  { key: 'deviceStatus', label: 'Device Status' },
];

const UPS_healthy_data = removeServerWithDuplicateUPS(sortedData).flatMap((server, index) => {
  return (
    (server?.additionalInfo || [])
      .filter(eachInfo => eachInfo.info_status === "Online")
      .map(eachInfo => {
        return ({
          site: eachInfo.site,
          deviceType: eachInfo.info_type,
          deviceLabel: eachInfo.info_label,
          deviceOnlineDays: (
            <div style={{fontWeight: '600'}}>
              <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
              </svg>
              <span style={{ color: '#22BE63', marginLeft: '.2rem' }}>{eachInfo.UPSOnlineDays}d</span>
            </div>
          ),
          deviceOfflineSince: '-',
          deviceStatus: (
            <span style={{ color: '#22BE63', fontWeight: '600'}}>
                {eachInfo.info_status}
             </span>
          ),
        })
      })
  )}
);

// Headers for Switch Alerts table
const switch_alerts_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'serverName', label: 'Server Name' },
  { key: 'switchId', label: 'Switch ID' },
  { key: 'totalPorts', label: 'Total Ports' },
  { key: 'activityTime', label: 'Activity Time' },
  { key: 'switchOfflineSince', label: 'Switch Offline Since' },
  { key: 'switchStatus', label: 'Switch Status' },
];

// Data for Switch Alerts table
const switch_alerts_data = sortedData
  .filter(server => server.switchInfo !== null && server.switchInfo.switch_status === 0)
  .map((server, index) => {
  
  return (
    {
      site: server.site,
      serverName: server.serverName,
      switchId: server.switchInfo.switch_id,
      totalPorts: server.switchInfo.total_ports,
      activityTime: (
      <div style={{fontWeight: '600'}}>
        <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
        </svg>
        <span style={{ color: "#C82333", fontWeight: '600' }}>{daysSince(server.switchInfo.switch_offline_since)}d</span>   
      </div>
      ),
      switchOfflineSince: dateTimeUTC(server.switchInfo.switch_offline_since),
      switchStatus: (
        <span style={{ color: "#C82333", fontWeight: '600' }}>
          Offline
        </span>
      )
    } 
  )
});

// Headers for Healthy Switches table
const switches_healthy_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'serverName', label: 'Server Name' },
  { key: 'switchId', label: 'Switch ID' },
  { key: 'totalPorts', label: 'Total Ports' },
  { key: 'activityTime', label: 'Activity Time' },
  { key: 'switchOfflineSince', label: 'Switch Offline Since' },
  { key: 'switchStatus', label: 'Switch Status' },
];

// Data for Healthy Switches table
const switches_healthy_data = sortedData
  .filter(server => server.switchInfo !== null && server.switchInfo.switch_status === 1)
  .map((server, index) => {
  
  return (
    {
      site: server.site,
      serverName: server.serverName,
      switchId: server.switchInfo.switch_id,
      totalPorts: server.switchInfo.total_ports,
      activityTime: (
      <div style={{fontWeight: '600'}}>
        <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
        </svg>
        <span style={{ color: "#22BE63" }}>{server.switchInfo.switch_online_days}d</span>    
      </div>
      ),
      switchOfflineSince: '-',
      switchStatus: (
        <span style={{ color: "#22BE63", fontWeight: '600' }}>
          Online
        </span>
      )
    } 
  )
});

// Headers for Storage Alerts table
const storage_alerts_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'serverName', label: 'Server Name' },
  { key: 'storageId', label: 'Storage ID' },
  { key: 'activityTime', label: 'Activity Time' },
  { key: 'storageOfflineSince', label: 'Storage Offline Since' },
  { key: 'storageStatus', label: 'Storage Status' }
]

// Data for Storage Alerts table
const storage_alerts_data = sortedData.flatMap((server, index) => (
  (server?.storage || [])
  .filter(eachStorage => eachStorage.storageStatus === 'Offline')
  .map((eachStorage, index) => (
    {
      site: server.site,
      serverName: server.serverName,
      storageId: eachStorage.storageId,
      activityTime: (
        <div style={{fontWeight: '600'}}>
          <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
          </svg>
          <span style={{ color: '#C82333', marginLeft: '.2rem', fontWeight: '600' }}>{daysSince(eachStorage.storageOfflineSince)}d </span>
        </div>
      ),
      storageOfflineSince: dateTimeUTC(eachStorage.storageOfflineSince),
      storageStatus: (
        <span style={{ color: "#C82333", fontWeight: '600' }}>{eachStorage.storageStatus}</span>
      )
    }
  ))
));

// Headers for Healthy Storages table
const storage_healthy_columns = [
  { key: 'site', label: 'Site Name' },
  { key: 'serverName', label: 'Server Name' },
  { key: 'storageId', label: 'Storage ID' },
  { key: 'activityTime', label: 'Activity Time' },
  { key: 'storageOfflineSince', label: 'Storage Offline Since' },
  { key: 'storageStatus', label: 'Storage Status' }
]

const storage_healthy_data = sortedData.flatMap((server, index) => (
  (server?.storage || [])
  .filter(eachStorage => eachStorage.storageStatus === 'Online')
  .map((eachStorage, index) => (
    {
      site: server.site,
      serverName: server.serverName,
      storageId: eachStorage.storageId,
      activityTime: (
        <div style={{fontWeight: '600'}}>
          <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
          </svg>
          <span style={{ color: '#22BE63', marginLeft: '.2rem' }}>{eachStorage.storageOnlineDays}d</span>
        </div>
      ),
      storageOfflineSince: '-',
      storageStatus: (
        <span style={{ color: "#22BE63", fontWeight: '600' }}>{eachStorage.storageStatus}</span>
      )
    }
  ))
));

  return (
     <>
    {/* {!isSmallScreen &&  <div className='health-info-sidebbar' >
     <SideBar />
    </div>} */}

      {user ?
        initialLoad ?
          //  When user has not created a business
          (fetchUserResponse.role === null && !fetchUserResponse.businesses.length) ? 
            <OnboardingBusiness loading={initialLoad} setLoading={setInitialLoad}/>
            : 
            <div className='health-info-loading-img'>
              <div>
                <RingLoader size={ isSmallScreen ? 200 : 400} color="#F49523"/>
              </div>          
              <div className='health-info-loading-img-footer'>
                <Footer url={webURL}/>  
              </div>
            </div>
        // loading is false
        :
          <>
          {/* When user has created a business but no sites setup */}
          {(fetchUserResponse.role === null && fetchUserResponse.businesses.length === 1 && !businessNoSites.length) ? 
            <OnboardingSite/>
            :
            <>
            <div className='health-info-container'>
              <Container >
                  {/* select business dropdown menu */}
                  {/* top banner -> welcome + current time */}
                  <div className='welcome-container'>
                    <span className='health-info-welcome-text'>Welcome to your Monitoring Analytics </span>                    
                    {/* <br></br> */}
                    <div className='health-info-welcome-time'>                   
                      {date.toLocaleString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </div>
                  </div>

                  {/* select dropdown menu */}
                  <div className='selectors-container'>
                    {/* select business dropdown menu */}
                    <div>
                      <Select
                        label="Select a business"
                        value={selectedBusiness}
                        onChange={handleBusinessChange}
                        options={businessNamesWithSitesOptions}
                        size='sm'
                        className='select-healthInfo'
                      />                     
                    </div>       
                    
                    {/* select site dropdown menu */}
                    <div className='site-and-group-selectors-container'>
                       {/* Group selector - ONLY shown when grouping is active */}
                       {isGroupingActive && groupOptions.length > 1 && (
                        <div>
                          <Select
                            label="Select a group"
                            value={selectedGroup}
                            onChange={handleGroupChange}
                            options={groupOptions}
                            size='sm'
                            className='select-healthInfo'
                          />
                          <div>
                        <span className='total-site-count'>
                          Total sites:
                        </span>
                        <span className='total-site-count-value'>
                          {displayedSitesOptions.length-1}
                        </span>
                      </div>
                        </div>
                      )}

                      {/* Site selector */}
                      <div className='site-selector-container'>
                        <Select
                          label="Select a site"
                          value={selectedSite}
                          onChange={handleSiteChange}
                          options={displayedSitesOptions}
                          size='sm'
                          className='select-healthInfo'
                        />
                        {selectedBusiness && ['admin', 'tla'].includes(
                               userBusinessRole || ''
                              ) && (
                         <GenericTooltip content="Click to Open Site Group Manager" placement='top' tooltipStyle={{ background: 'black' }}>
                           <button
                            className='manage-site-group-btn'
                            onClick={() => setShowGroupManager(true)}
                            size="sm"
                            variant="ghost"
                          >
                            <img src={siteGroupIcon} alt="group-icon" className='site-group-icon'/>
                          </button>
                        </GenericTooltip>
                        )}
                      </div>
                      
                    </div>

                     {/* select VMS dropdown menu */}
                    <div>
                      <Select
                        label="Select a VMS"
                        value={selectedVMS}
                        onChange={handleVMSChange}
                        options={uniqueVMSTypes}
                        size='sm'
                        className='select-healthInfo'
                      />
                    </div>

                    {/* Group Manager Modal/Page */}
                      {showGroupManager && (
                    <Modal 
                      size='xl' 
                      show={showGroupManager} 
                      onHide={handleCloseGroupManager}
                      position='center'
                    >
                      <Modal.Header>
                        <Modal.Title>
                          Manage Site Groups - {selectedBusiness}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <SiteGroupManager
                          selectedBusiness={selectedBusiness}
                          allSites={sortedSites}
                          userEmail={user}
                          onClose={handleCloseGroupManager}
                        />
                      </Modal.Body>
                    </Modal>
                      )}
                    
                  </div>
                  
                  {
                    !loadingSelectedBusiness  ?
                  <>

                  {/* mapped SI name on selected site */}
                  { 
                    (selectedSite !== 'ALL' && selectedSI)  &&  (
                     <div className='si-name-container health-info-select-label'>
                       <label className='health-info-select-label' >
                        SI: <span style={{ opacity: '0.8' }}>{selectedSI}</span>
                      </label> 
                     </div>
                    )
                  }
                        
                    {/* Health Charts */}
                    <div style={{marginTop: '2rem'}}>
                      <Row className="justify-content-md-center">                
                          <HealthCharts
                            data={chartData}
                            totalOnlineServers={totalOnlineServers}
                            totalOfflineServers={totalOfflineServers}
                            totalOnlineDevices={totalOnlineDevices}
                            totalOfflineDevices={totalOfflineDevices}
                            totalOnlineAnalytics={totalOnlineAnalytics}
                            totalOfflineAnalytics={totalOfflineAnalytics}
                            totalOnlineSwitches={totalOnlineSwitches}
                            totalOfflineSwitches={totalOfflineSwitches}
                            totalOnlineUPS={totalOnlineUPS}
                            totalOfflineUPS={totalOfflineUPS}
                            totalServers={totalServers}
                            totalDevices={totalDevices}
                            totalAnalytics={totalAnalytics}
                            totalSwitches={totalSwitches}
                            totalUPS={totalUPS}
                          />
                      </Row>

                      {/* Port Layout */}
                      {
                      canAccess('port-cycle', userBusinessRole) &&
                        (totalOnlineSwitches?
                        <div className="view-port-btn" onClick={handleOpenPortLayout}>
                          <img src={PORT_UP_WHITE_ICON} className="port-border-white-icon" style={{height: '1.5rem'}} alt="port-up-white-icon"/>
                          <img src={PORT_UP_BORDER_ICON} className="port-border-green-icon" style={{height: '1.5rem'}} alt="port-up-white-icon"/> 
                          <p>View Port Layout</p>
                        </div>
                        :
                        <CustomTooltipPortLayout text = "No switches available">
                        {/* <GenericTooltip content="No switches available" placement="bottom"> */}
                          <div className="view-port-btn-disabled">
                            <img src={PORT_UP_WHITE_ICON} style={{height: '1.5rem'}} alt="port-up-white-icon"/> 
                            <p>View Port Layout</p>
                          </div>
                        {/* </GenericTooltip> */}
                        </CustomTooltipPortLayout>
                        )
                      }                    

                      {/* Modal to view switches */}
                      <Modal size={totalPortsAllSwitches > 8 ? 'lg' : 'md'} show={isPortLayoutVisible} onHide={handleClosePortLayout}>
                        <Modal.Header closeButton style={{background: '#334066', height: '3em', paddingTop: '.2em' }}>
                          <Modal.Title>
                            <span>Switches</span>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="switches-modal-body" >
                        <div className="switches-container" style={{justifyContent: (totalOnlineSwitches === 1 || totalOnlineSwitches === 2) && 'center'}}>
                          {sortedData.map((server, index) =>
                            (server.switchInfo !== null) &&
                              <div key={index} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: '3rem'}}>
                                <div className="switch-container">
                                  {/* only display switch ports if total_ports > 0 */}
                                    <p className="switch-site-name"><b>Site:</b> {server.site}</p>
                                    <p className="switch-server-name"><b>Server:</b> {server.serverName}</p>
                                      <div className="ports-container">
                                      {server.switchInfo.total_ports > 0 ?
                                      <>
                                        <div className="ports-top-half">
                                          {/* top half - odd numbers */}
                                          {Array.from({length: server.switchInfo.total_ports}, (_, index) => index +1 ).filter((index) => index % 2 !== 0).map((port) =>                                    
                                            <div className="port-num-img" key={`port-div-${port}`}> 
                                              <p className="port-text">{port}</p>
                                              {/* Check if there is any connected port that exists in the port layout. If no, use black image */}
                                              {server.switchInfo.connected_ports.some(connected_port => connected_port.port_number === port ) ?
                                              // Filter out these ports. For each filterd port, check its status and update the image accordingly
                                                server.switchInfo.connected_ports.filter(connected_port => connected_port.port_number === port ).map((filtered_port) =>
                                                  <Port 
                                                    key={`port-${port}-${filtered_port.port_number}`}
                                                    filtered_port = {filtered_port}
                                                    server = {server}
                                                    user = {user}
                                                    position = "top"
                                                  />
                                                  )
                                              : 
                                                <img 
                                                  key={`unconnected-port-${port}`}
                                                  className='port-icon-unconnected'
                                                  src={PORT_UP_ICON}
                                                  alt="port_icon"
                                                />
                                              }
                                            </div>                      
                                          )}
                                        </div>

                                        <div className="ports-bottom-half">
                                          {/* bottom half - even numbers */}
                                          {Array.from({ length: server.switchInfo.total_ports }, (_, index) => index + 1)
                                            .filter((index) => index % 2 === 0)
                                            .map((port) => (
                                              <div className="port-num-img" key={`port-div-bottom-${port}`}>
                                                {/* Check if there is any connected port that exists in the port layout. If no, use normal image */}
                                                {server.switchInfo.connected_ports.some((connected_port) => connected_port.port_number === port) ? (
                                                  // Map over connected ports and render Port component
                                                  server.switchInfo.connected_ports
                                                    .filter((connected_port) => connected_port.port_number === port)
                                                    .map((filtered_port) => (
                                                      <Port
                                                        key={`port-bottom-${port}-${filtered_port.port_number}`} // Unique key for Port component
                                                        filtered_port={filtered_port}
                                                        server={server}
                                                        user={user}
                                                        position="bottom"
                                                      />
                                                    ))
                                                ) : (
                                                  <img
                                                    key={`unconnected-port-bottom-${port}`} // Unique key for the unconnected port image
                                                    className="port-icon-unconnected"
                                                    src={PORT_DOWN_ICON}
                                                    alt="port_icon"
                                                  />
                                                )}
                                                <p className="port-text">{port}</p>
                                              </div>
                                            ))}
                                        </div>
                                        </>

                                        :
                                        <p>No ports available</p>
                                      } 
                                      </div>
                                  {/* </> */}
                                  {/* : */}
                                  {/* <p>No ports available</p> */}
                                  {/* } */}
                                </div>
                              </div>
                            )}
                          </div>
                        </Modal.Body>
                      </Modal>
                        
                      {/* cards */}
                      <Row className="health-cards-container">
                        <Col lg={4}>
                          {/* <div className='health-cards'> */}
                          <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                            <Row id='health-card-container'>
                              <Col id='health-card-icon' xs={3} sm={3} lg={3}>
                                <FontAwesomeIcon icon={faBell} style={{ color: 'white'}}/>
                              </Col>
                              <Col xs={9} sm={9} lg={9}>
                                <Row>
                                  <div id='health-card-title'>UNACKNOWLEDGED EVENTS</div>
                                </Row>
                                <Row>
                                  <div id='health-card-content'>{unAckAlerts.length}</div>
                                </Row>
                                <Row>
                                <div id='health-card-action'>
                                    <Button 
                                      id='health-card-action-btn'
                                      disabled={!unAckAlerts.length}
                                        variant='text'
                                        onClick={handleShowUnAckAlerts}>
                                        Click here to view
                                    </Button>
                                  </div>
                                </Row>
                              </Col>                         
                            </Row>                     
                          </Card>
                          {/* </div> */}
                        </Col>
                        
                        <Col lg={4}>
                        {/* <div className='health-cards'> */}
                          <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                            <Row id='health-card-container'>
                              <Col id='health-card-icon' xs={3} sm={3} lg={3}>
                              <FontAwesomeIcon icon={faServer} style={{ color: 'white' }}/>
                              </Col>
                              <Col xs={9} sm={9} lg={9}>
                                <Row>
                                  <div id='health-card-title'>SERVERS OFFLINE IN PAST WEEK</div>
                                </Row>
                                <Row>
                                  <div id='health-card-content'>{pastWeekOfflineServers.length}</div>
                                </Row>
                                <Row>
                                  <div id='health-card-action'>
                                    <Button 
                                      id='health-card-action-btn'
                                      disabled={!pastWeekOfflineServers.length}
                                        variant='text'
                                        onClick={handleShowPastWkOfflineServer}>
                                        Click here to view
                                    </Button>
                                  </div>
                                </Row>
                              </Col>                         
                            </Row>                     
                          {/* </div> */}
                          </Card>
                        </Col>

                        <Col lg={4}>
                        {/* <div className='health-cards'> */}
                          <Card className='glass-card no-hover no-shadow' style={{backgroundColor: 'rgba(255, 255, 255, 0.2)'}}>
                            <Row id='health-card-container'>
                              <Col id='health-card-icon' xs={3} sm={3} lg={3}>
                              <FontAwesomeIcon icon={faVideoCamera} style={{ color: 'white' }}/>
                              </Col>
                              <Col xs={9} sm={9} lg={9}>
                                <Row>
                                  <div id='health-card-title'>CAMERAS OFFLINE IN PAST WEEK</div>
                                </Row>
                                <Row>
                                  <div id='health-card-content'>{pastWeekOfflineDevices().length}</div>
                                </Row>
                                <Row>
                                <div id='health-card-action'><Button id='health-card-action-btn'  disabled={!pastWeekOfflineDevices().length} variant='text' onClick={handleShowPastWkOfflineDevices}>Click here to view</Button></div>
                                </Row>
                              </Col>                         
                            </Row>                     
                          {/* </div> */}
                          </Card>
                        </Col>
                      </Row>

                      {/* Server alert table starts  */}
                      {sortedDataAlerts.length ?
                      <>
                      <div
                        ref={(el) => (alertTableRefs.current.servers = el)}
                        className='alert-table-container'
                      >                   
                          <span className='health-info-alerts-text'>Server Alerts</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>
                          {(totalOfflineServers !== 0) && <div className="bell-icon-badge-alert-table">{totalOfflineServers}</div>}
                      </div>
                      <Row>                  
                        <div style={{ padding: '1em' }}>
                          <Table 
                            columns={server_alerts_columns}
                            data={server_alerts_data}
                            className={`alert-table ${highlightedTable === 'servers' ? 'highlighted' : ''}`}
                          />
                        </div>
                      </Row>
                      </>
                      : 
                      <></>
                      }
                      {/* Server alert table ends  */}

                      {/* Storage data starts  */}
                      {alertStorage() ?
                      <>
                      <div
                        ref={(el) => (alertTableRefs.current.storages = el)}
                        className='alert-table-container'
                      >                   
                          <span className='health-info-alerts-text'>Storage Alerts</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>
                          {(totalOfflineStorages !== 0) && <div className="bell-icon-badge-alert-table">{totalOfflineStorages}</div>}
                      </div>                     
                      <Row>
                        <div style={{ padding: '1em' }}> 
                          <Table 
                            columns={storage_alerts_columns} 
                            data={storage_alerts_data}
                            className={`alert-table ${highlightedTable === 'storages' ? 'highlighted' : ''}`}
                            // className={`alert-table ${highlightedTable?.includes('storages') ? 'highlighted' : ''}`}
                          />
                        </div>
                      </Row>
                      </>
                      :
                      <></>
                      }         
                      {/* Storage data ends  */}
                      
                      {/* Analytic alerts starts  */}                  
                      {totalOfflineAnalytics ?
                      <>
                        <div
                          ref={(el) => (alertTableRefs.current.analytics = el)}
                          className='alert-table-container'
                        >                   
                          <span className='health-info-alerts-text'>Analytic Alerts</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>
                          {(totalOfflineAnalytics !== 0) && <div className="bell-icon-badge-alert-table">{totalOfflineAnalytics}</div>}
                        </div>
                      <Row>
                        <div style={{ padding: '1em' }}>        
                            <Table 
                            columns={analytic_alerts_columns}
                            data={analytic_alerts_data}
                            className={`alert-table ${highlightedTable === 'analytics' ? 'highlighted' : ''}`}
                          />
                          </div>
                      </Row>
                      </>
                      :
                      <></>
                      }
                      {/* Analytic alerts ends  */}

                      {/* UPS alerts starts  */}
                      { alertAdditionalDevices() ?
                      <>
                      <div
                        ref={(el) => (alertTableRefs.current.ups = el)}
                        className='alert-table-container'
                      >                   
                          <span className='health-info-alerts-text'>UPS Alerts</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>
                          {(totalOfflineUPS !== 0) && <div className="bell-icon-badge-alert-table">{totalOfflineUPS}</div>}
                      </div>  
                      <Row>
                        <div style={{ padding: '1em' }}>
                            <Table 
                              columns={UPS_alerts_columns} 
                              data={UPS_alerts_data}
                              className={`alert-table ${highlightedTable === 'ups' ? 'highlighted' : ''}`}
                            />
                          </div>
                      </Row>
                      </>
                      :
                      <></>
                      }                  
                      {/* UPS alerts ends  */}
                  
                      {/* Switch alerts starts  */}
                      {/* <div className='alert-table-container'>                   
                          <span className='health-info-alerts-text'>Switch Alerts - In progress</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>              
                      </div> */}
                      {totalOfflineSwitches ?
                      <>
                      <div
                        ref={(el) => (alertTableRefs.current.switches = el)}
                        className='alert-table-container'
                      >                   
                          <span className='health-info-alerts-text'>Switch Alerts</span>                   
                          <FontAwesomeIcon icon={faBell} className='health-info-alerts-icon'/>
                          {(totalOfflineSwitches !== 0) && <div className="bell-icon-badge-alert-table">{totalOfflineSwitches}</div>}
                      </div>                     
                      <Row>
                        <div style={{ padding: '1em' }}> 
                            <Table 
                              columns={switch_alerts_columns} 
                              data={switch_alerts_data}
                              className={`alert-table ${highlightedTable === 'switches' ? 'highlighted' : ''}`}
                            />
                        </div>
                      </Row>
                      </>
                      :
                      <></>
                      }         
                      {/* Switch alerts ends  */}

                      <br></br>

                   {/* Healthy sites starts  */}
                    <span className='bottom-toggles'>Healthy Servers</span>
                      <Button variant='text'style={{ color: 'white' }} onClick={toggleHealthTableVisibility}>
                        {isHealthTableVisible ? 
                          <FontAwesomeIcon icon="fa-solid fa-angles-right" className='bottom-toggles-arrow'/> :
                          <FontAwesomeIcon icon="fa-solid fa-angles-down" className='bottom-toggles-arrow' />
                        }
                      </Button>
                      {isHealthTableVisible && (
                      <Row>
                        <div style={{ padding: '1em' }}>
                          { sortedDataHealthy.length ? (
                          <Table
                            columns = {servers_healthy_columns} 
                            data={servers_healthy_data}
                          />
                          )
                          :
                          (totalServers ? 
                              <span className='healthy-sites-msg' >No site is healthy.</span>
                            : 
                              <span className='no-data-avail-msg' >No server data available.</span>)
                          }
                      </div>
                      </Row>
                      )}
                      {/* Healthy sites ends  */}

                      {/* Healthy Storage starts  */}                
                      <span className='bottom-toggles'>Healthy Storages</span>
                      <Button variant='text'style={{ color: 'white' }} onClick={toggleStorageTableVisibility}>
                        {isStorageTableVisible ? 
                          <FontAwesomeIcon icon="fa-solid fa-angles-right" className='bottom-toggles-arrow'/> :
                          <FontAwesomeIcon icon="fa-solid fa-angles-down" className='bottom-toggles-arrow' />
                        }
                      </Button>
                      {isStorageTableVisible && (
                      <Row>
                        <div style={{ padding: '1em' }}>
                          {totalStorages ?
                            <Table 
                            columns = {storage_healthy_columns}
                            data = {storage_healthy_data}
                            />
                          : <span className="no-data-avail-msg">No storage data available.</span>
                          }
                        </div>
                      </Row>                  
                      )}
                      {/* Healthy Storage ends  */}

                      {/* Healthy analytics starts  */}
                      <span className='bottom-toggles'>Healthy Analytics</span>
                      <Button variant='text'style={{ color: 'white' }} onClick={toggleHealthyAnalyticsTableVisibility}>
                        {isHealthyAnalyticsTableVisible ? 
                          <FontAwesomeIcon icon="fa-solid fa-angles-right" className='bottom-toggles-arrow'/> :
                          <FontAwesomeIcon icon="fa-solid fa-angles-down" className='bottom-toggles-arrow'/>
                        }
                      </Button>

                  {isHealthyAnalyticsTableVisible && (
                  <Row>
                    <div style={{ padding: '1em' }}>
                      { totalOnlineAnalytics > 0 ? 
                      <Table 
                        columns = {analytic_healthy_columns}
                        data = {analytic_healthy_data}
                      />
                      :
                        (totalAnalytics ?
                          <span className='healthy-sites-msg'>No analytic is healthy.</span>
                        :
                          <span className='no-data-avail-msg'>No analytics data available.</span>)
                      }
                  </div>
                  </Row>
                  )}
                  {/* Healthy analytics ends  */}

                      {/* Healthy UPS starts  */}
                      <span className='bottom-toggles'>Healthy UPS</span>
                      <Button variant='text'style={{ color: 'white' }} onClick={toggleHealthyUPSTableVisibility}>
                        {isHealthyUPSTableVisible ? 
                          <FontAwesomeIcon icon="fa-solid fa-angles-right" className='bottom-toggles-arrow'/> :
                          <FontAwesomeIcon icon="fa-solid fa-angles-down" className='bottom-toggles-arrow' />
                        }
                      </Button>

                      {isHealthyUPSTableVisible && (
                      <Row>
                        <div style={{ padding: '1em' }}>
                          { totalOnlineUPS > 0 ? (
                          <Table 
                            columns = {UPS_healthy_columns}
                            data = {UPS_healthy_data}
                          />
                          )   
                          :
                            (totalUPS ?
                              <span className='healthy-sites-msg' >No UPS is healthy.</span>
                            :
                              <span className='no-data-avail-msg'>No UPS data available.</span>)
                          }
                      </div>
                      </Row>
                      )}
                      {/* Healthy UPS ends  */}

                      {/* Healthy Switches starts  */}
                      <span className='bottom-toggles'>Healthy Switches</span>
                      <Button variant='text'style={{ color: 'white' }} onClick={toggleHealthySwitchesTableVisibility}>
                        {isHealthySwitchesTableVisible ? 
                          <FontAwesomeIcon icon="fa-solid fa-angles-right" className='bottom-toggles-arrow'/> :
                          <FontAwesomeIcon icon="fa-solid fa-angles-down" className='bottom-toggles-arrow' />
                        }
                      </Button>
                      
                      {isHealthySwitchesTableVisible && (
                        <Row>
                        <div style={{ padding: '1em' }}>
                          {totalOnlineSwitches > 0 ? (
                          <Table 
                            columns = {switches_healthy_columns}
                            data = {switches_healthy_data}
                          />
                          )
                          :
                          (totalSwitches ?
                            <span className='healthy-sites-msg' >No Switch is healthy.</span>
                            :
                            <span className='no-data-avail-msg'>No Switch data available.</span>)
                          } 
                        </div>
                      </Row>
                      )}
                      {/* Healthy Switches ends  */}

                    {/* Map starts */}
                    </div>
                      {                    
                        sortedDataByColor.length ?
                        (
                        <MapContainer
                          ref={map => {mapRef.current = map; setMapRefLoaded(true);}}
                          center={center}
                          zoom={5}
                          scrollWheelZoom={true}
                          style={{height: "600px", width: "100%", borderRadius: '0.3rem'}}
                          >
                            <MapReadyHandler onMapReady={(map) => {
                              mapRef.current = map;
                              setMapRefLoaded(true);
                            }} />

                          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              
                          <LayersControl position="topright">
                            <BaseLayer checked name="Map">
                              {/* Base layer */}
                              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                            </BaseLayer>


                            {/* Overlay layers */}
                            <Overlay checked name='Red Markers - Offline Servers'>
                              <LayerGroup>
                                {sortedDataByColor
                                  .filter(each => each.color === 'red')
                                  .map(each => (
                                    (each.servers[0]?.latitude &&  each.servers[0]?.longitude) &&
                                    <Marker 
                                      key={each.site}
                                      position={[each.servers[0]?.latitude, each.servers[0]?.longitude]}
                                      icon={redIcon}
                                      zIndexOffset={1000}
                                      eventHandlers={{
                                        click: () => {
                                          handleOpenSitePlan(each.servers[0]?.business, each.site, each.servers)
                                        },
                                      }}
                                    >
                                      {/* Tooltip for hover */}
                                      <Tooltip>
                                        <div  >
                                          <span className='map-sitename-label'>Business:</span> <span className='map-sitename-value'>{each.servers[0]?.business}&nbsp;|&nbsp;</span>
                                          <span className='map-sitename-label'>Site:</span> <span className='map-sitename-value'>{each.site}</span>
                                          <table className='table-container-map'>
                                            <tbody>
                                              <tr>
                                                <th>Server Name</th>
                                                <th>Server Status</th>
                                                <th>Offline Since</th>
                                                <th>Total Cameras</th>
                                              </tr>
                                              {each.servers.map(server => (
                                                <tr key={server.serverName}>
                                                  <td>{server.serverName}</td>
                                                  <td>{server.serverStatus}</td>
                                                  <td>{utcStrToLocal(server.serverOfflineSince)}</td>
                                                  <td>{server.totalDevices}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                          <span className='tooltip-siteplan'>Click on the marker to view/upload a site plan</span>
                                        </div>
                                      </Tooltip>                                      
                                    </Marker>
                                      ))}
                                  </LayerGroup>
                                </Overlay>

                            {/* Overlay layers */}
                            <Overlay checked name="Orange Markers - Offline Cameras">
                              <LayerGroup>
                                {sortedDataByColor
                                  .filter(each => each.color === 'orange')
                                  .map(each => (
                                    (each.servers[0]?.latitude &&  each.servers[0]?.longitude) &&
                                    <Marker 
                                    key={each.site}
                                    position={[each.servers[0]?.latitude, each.servers[0]?.longitude]}
                                    icon={orangeIcon}
                                    zIndexOffset={500}
                                    eventHandlers={{
                                      click: () => {
                                        handleOpenSitePlan(each.servers[0]?.business, each.site, each.servers)
                                      },
                                    }}
                                    >
                                      <Tooltip>
                                        <div>
                                        <span className='map-sitename-label'>Business:</span> <span className='map-sitename-value'>{each.servers[0]?.business}&nbsp;|&nbsp;</span>
                                          <span className='map-sitename-label'>Site name:</span> <span className='map-sitename-value'>{each.site}</span>
                                          <table className='table-container-map'>
                                            <tbody>
                                              <tr>
                                                <th>Server Name</th>
                                                <th>Server Status</th>
                                                <th>Total Cameras</th>
                                                <th>Offline Cameras</th>
                                              </tr>
                                              {each.servers.map(server => (
                                                <tr key={server.serverName}>
                                                  <td>{server.serverName}</td>
                                                  <td>{server.serverStatus}</td>
                                                  <td>{server.totalDevices}</td>
                                                  <td>{server.devicesOffline}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                          <span className='tooltip-siteplan'>Click on the marker to view/upload a site plan</span>
                                        </div>
                                      </Tooltip>
                                    </Marker>
                                  ))}
                              </LayerGroup>
                            </Overlay>

                            {/* Overlay layers */}
                            <Overlay checked name="Green Markers - All Healthy">
                              <LayerGroup>
                                {sortedDataByColor
                                  .filter(each => each.color === 'green')
                                  .map(each => (
                                    (each.servers[0]?.latitude &&  each.servers[0]?.longitude) &&
                                    <Marker 
                                      key={each.site}
                                      position={[each.servers[0]?.latitude, each.servers[0]?.longitude]}
                                      icon={greenIcon}
                                      zIndexOffset={0}
                                      eventHandlers={{
                                        click: () => {
                                          handleOpenSitePlan(each.servers[0]?.business, each.site, each.servers)
                                        },
                                      }}
                                    >
                                      
                                      <Tooltip>
                                        <div>
                                          <span className='map-sitename-label'>Business:</span> <span className='map-sitename-value'>{each.servers[0]?.business}&nbsp;|&nbsp;</span>
                                          <span className='map-sitename-label'>Site name:</span> <span className='map-sitename-value'>{each.site}</span>
                                          <table className='table-container-map'>
                                            <tbody>
                                              <tr>
                                                <th>Server Name</th>
                                                <th>Server Status</th>
                                                <th>Total Cameras</th>
                                                
                                              </tr>
                                              {each.servers.map(server => (
                                                <tr key={server.serverName}>
                                                  <td>{server.serverName}</td>
                                                  <td>{server.serverStatus}</td>
                                                  <td>{server.totalDevices}</td>
                                                
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                          <span className='tooltip-siteplan'>Click on the marker to view/upload a site plan</span>
                                        </div>
                                      </Tooltip>
                                      
                                    </Marker>
                                  ))}
                              </LayerGroup>
                            </Overlay>

                          </LayersControl>
                        </MapContainer>

                        ) : null
                      }

                  </>
                  :
                  localStorage.getItem('noServersData') === 'true' ?
                    <div style={{ color: '#e08a20', height: !isSmallScreen ? '25rem' : '1rem'  }}>No data found !</div>
                  :
                  <div className='loading-select-business'>
                    <RingLoader size={ !isSmallScreen ? 200 : 100} color="#F49523"/>
                  </div>
                }

                  {/* side bar cards for small screens  */}
                  {isSmallScreen && !initialLoad ? (
                      <SideBarSmallScreen/>
                    ) : null
                  }
                </Container>        
              
              {/* Site mapping */}
              <Modal className="modal-superwide-siteplan" size='xl' show={is2DSitePlanVisible} onHide={handleCloseSitePlan} position = "center">
                <Modal.Header>
                  <Modal.Title>Camera Placement Tool for site {pinSiteName} 
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
                  <SitePlan hwid={hwid} userBusinessRole={userBusinessRole}/>
                  <DragOverlay />
                </DndProvider>
                </Modal.Body>
              </Modal>

              {/* Past week offline server modal */}
              <Modal size='md' show={showPastWkOfflineServer} onHide={handleClosePastWkOfflineServer} position='center' >
                <Modal.Header>
                  <Modal.Title> Offline Servers Past Week
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  < OfflineServersPastWeek servers={pastWeekOfflineServers}/>
                </Modal.Body>
              </Modal>

              {/* Past week offline cameras modal */}
              <Modal size='md' show={showPastWkOfflineDevices} onHide={handleClosePastWkOfflineDevices} position='center' >
                <Modal.Header>
                  <Modal.Title> Offline Cameras Past Week
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <OfflineDevicesPastWeek devices={pastWeekOfflineDevices()}/>
                </Modal.Body>
              </Modal>

              {/* Unacknowledged alerts modal */}
              <Modal size='xl' show={showUnAckAlerts} onHide={handleCloseUnAckAlerts} position='center'>
                <Modal.Header>
                  <Modal.Title>Unacknowledged Alerts
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{background: '#071d2c', paddingRight:0 }}>
                  <UnAckAlerts unAckAlerts={unAckAlerts} userBusinessRole={userBusinessRole}/>
                </Modal.Body>
              </Modal>


                                            {/* SERVER ALERTS table  */}

                {/* Ninja Details Modal */}
                  <Modal size='xl' show={showNinjaModal} onHide={handleNinjaModalClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>
                          🖥️ System Details - {selectedServer?.serverName}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <NinjaDetails ninjaData={selectedServer?.ninjaDetail?.ninjaData} />
                    </Modal.Body>
                  </Modal>
            
                  {/* modal to view device details */}
                  <Modal size='lg' show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Cameras</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <SelectedServer serverOfflineSince={selectedServer?.serverOfflineSince==='N/A' ? '-': utcStrToLocal(selectedServer?.serverOfflineSince)} serverStatus={selectedServer?.serverStatus}  serverName={selectedServerName} site={selectedServer?.site} userBusinessRole={userBusinessRole}/>
                    </Modal.Body>
                  </Modal>
            
                  {/* modal to view ack warning */}
                  <Modal size='md' show={showAckWarning} onHide={handleAckWarningClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Fault Acknowledgement</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>       
                        <div style={{ color: '#E0E0E0' }}>Do you want to acknowledge the fault for <span style={{ color: '#22BE63' }}>{selectedServer?.serverName}</span> ?</div>
                        <div style={{ color: '#E0E0E0' }}>Enter your acknowledgment note below and click “Acknowledge” to confirm, or “Cancel” to dismiss.</div>
                        <div>
                          <textarea
                            placeholder='Enter your acknowledgement note here (required)'
                            value={ackNote}
                            onChange={handleAckNoteChange}
                            rows={4}
                            className='ack-textarea'
                          />
                        <div className='ack-textarea-footer'>
                          <div className={`char-counter ${ackNote.length > MAX_LENGTH - 20 ? 'warn' : ''}`}>
                            {MAX_LENGTH - ackNote.length} characters left
                          </div>
                          <div className='ack-textarea-footer-right'><Button variant='ghost' size='small' onClick={() => setAckNote('')}>Clear text</Button></div>
                        </div>
                        
                        </div>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1em' }}>              
                          <Button size='small' variant='danger' onClick={() => handleACK(selectedServer?.serverName)}>Acknowledge</Button>
                          <Button size='small' variant='ghost' onClick={handleAckWarningClose}>Cancel</Button>
                        </div>       
                    </Modal.Body>
                  </Modal>

                     <Modal size='md' show={showAckStatus} onHide={() => setShowAckStatus(false)}>     
                      <Modal.Header closeButton>
                        <Modal.Title>Fault Acknowledged</Modal.Title>
                      </Modal.Header>                              
                      <Modal.Body>
                        <div className="ack-modal-body">
                          <div className="ack-status-banner">
                            <i style={{ fontSize: '1.3em' }} className="fa-solid fa-circle-check"></i>
                            <span>This fault has been successfully acknowledged</span>
                          </div>

                        <div className="ack-info">
                          <div className="ack-row">
                            <div className="ack-icon user"></div>
                            <div>
                              <div className="ack-label">
                                <i class="fa-solid fa-user"></i>
                                <span style={{ marginLeft: '1em' }}>ACKNOWLEDGED BY</span>
                              </div>
                              <div className="ack-value">{selectedServer?.serverAckData?.ackBy}</div>
                            </div>
                          </div>

                          <div className="ack-row">
                            <div className="ack-icon time"></div>
                            <div>
                              <div className="ack-label">
                                <i class="fa-solid fa-clock"></i>
                                <span style={{ marginLeft: '1em' }}>ACKNOWLEDGED AT</span>
                              </div>
                              <div className="ack-value">{convertUtcToLocal(selectedServer?.serverAckData?.ackTime)}</div>
                            </div>
                          </div>

                          {selectedServer?.serverAckData?.ackNote && (
                            <div className="ack-note-section">
                              <div className="ack-label">
                                <i style={{ marginLeft: '0.7em' }} class="fa-solid fa-comment"></i>
                                <span style={{ marginLeft: '1em' }}>ACKNOWLEDGMENT NOTE</span>
                              </div>
                              <div className="ack-note-box">{selectedServer.serverAckData.ackNote}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button size='small' variant='ghost' onClick={() => setShowAckStatus(false)}>Cancel</Button>
                    </Modal.Footer>
                  </Modal>

                    {/* Modal for matterport   */}
                    <Modal size='xl' show={showMatterportModal} onHide={handleCloseMatterportModal} position='center'>
                      <Modal.Header closeButton className='matterport-modal-header-container'>                       
                          <Modal.Title>
                            3D Site View - {pinSiteName}
                                                         
                            <div className='matterport-header-btns-container'>
                              { (userBusinessRole === 'tla' || userBusinessRole === 'admin')  // enable camera-tag association edit for tla and admin users only
                                &&                              
                              <GenericTooltip content="Camera Tag Association">
                                <Button variant='ghost' style={{ marginLeft: '-0.9em' }} onClick={handleMappterportEditTag}>
                                  <span className='matterport-edit-tag-icon'>
                                    <i class="fas fa-edit"></i>
                                  </span>
                                </Button>                                
                              </GenericTooltip>
                              }

                              {/* enable Edit tag mode for tla user only */}
                              { (userBusinessRole === 'tla' || userBusinessRole === 'admin')
                                &&
                              <GenericTooltip content={editMode ? "Exit Edit Tag Mode" : "Enter Edit Tag Mode"}>
                                <Button
                                  variant="ghost"
                                  className='matterport-edit-tag-icon'
                                  onClick={() => setEditMode(prev => !prev)}
                                >
                                  <span style={{ display: 'inline-flex', alignItems: 'center', color: editMode ? '#FF5F1F' :'#ccc' }}>
                                    <i class="fas fa-tags"></i>                          
                                  </span>
                                </Button>
                              </GenericTooltip>     
                                }                         

                              {/* Delete tag for tla user only */}
                              { userBusinessRole === 'tla' &&
                              <GenericTooltip content={"Unmap 3D Model from site - " + pinSiteName}>
                                <Button variant='ghost' style={{ marginLeft: '0.5em' }} onClick={handleMappterportUnmapWarningModal}>
                                  <span className='matterport-edit-tag-icon'>
                                    <i class="fas fa-trash"></i>
                                  </span>
                                </Button>
                              </GenericTooltip>
                              }
                            </div>
                            
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <MatterportModelViewer 
                          modelId={selectedMatterPortModelId}
                          hwid={hwid}
                          siteName={pinSiteName}
                          tags={tags}
                          url={url}
                          editMode={editMode}                                                
                          style={{ display: selectedMatterPortModelId ? 'block' : 'none' }}       
                          />
                         
                      </Modal.Body>
                    </Modal>

                     {/* Modal to choose Matterport or General 2D */}
                    <Modal size='sm' show={showSitePlanTypeModal} onHide={handleCloseSitePlanTypeModal} position='center'>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          <div>
                            Select a site plan type
                          </div>
                          <div style={{ fontSize: '0.7em', color: '#ccc', marginTop: '0.5em' }}>
                            {pinSiteName}
                          </div>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className='site-plan-type-selection-container'>
                          <Button variant='gradient' onClick={() => {
                           handleMappterportEditOrConfig();
                            setShowSitePlanTypeModal(false);
                          }} style={{ marginBottom: '2em', width: '100%' }} block>
                            <span style={{ marginRight: '0.5em' }}><i className="fa-solid fa-cube"></i></span>
                            3D Site View
                          </Button>
                          <Button variant='gradient' onClick={() => {
                            setShowSitePlanTypeModal(false);
                            setIs2DSitePlanVisible(true);
                          }} style={{ width: '100%' }} block>
                            <span style={{ marginRight: '0.5em' }}><i className="fa-solid fa-table-columns"></i></span>
                            2D Site View
                          </Button>

                        </div>                        
                      </Modal.Body>
                    </Modal>

                    {/* Modal for editing matterport model tags  */}
                    <Modal size='xl' show={showMatterportModelEdit} onHide={() => setShowMatterportModelEdit(false)} position='center'>
                      <Modal.Header closeButton>
                        <Modal.Title>Camera-Tag Mapping</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                         <CameraTagMapping
                          tags={tags} 
                          hwid={hwid} 
                          modelId={selectedMatterPortModelId}
                          onModalClose={() => setShowMatterportModelEdit(false)}
                        />
                      </Modal.Body>
                    </Modal>

                    {/* Modal for Matterport Configuration */}
                    <Modal size='md' show={showMatterportModelConfig} onHide={() => setShowMatterportModelConfig(false)} position='center'>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          <div>
                            Matterport Configuration
                          </div>
                          <div style={{ fontSize: '0.7em', color: '#ccc', marginTop: '0.5em' }}>
                            {pinSiteName}
                          </div>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <MatterportConfig 
                          hwid={hwid}
                          site={pinSiteName}
                          setTags={setTags}
                          setModelId={setSelectedMatterportModelId}
                          setShowMatterportModal={setShowMatterportModal}
                          handleCloseMatterportModelConfig={handleCloseMatterportModelConfig}
                        />
                      </Modal.Body>
                    </Modal>

                    {/* Model for unmap warning when tla user tries to unmap the matterport model from the site */}
                    <Modal size='md' show={showMatterportUnmapWarning} onHide={handleCloseMatterportUnmapWarningModal} position='center'>
                      <Modal.Header closeButton>
                        <Modal.Title>Unmap 3D Model from Site</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className='matterport-unmap-warning-text'>Are you sure you want to unmap this 3D model from site <span style={{ fontWeight: 'bold' }}>{pinSiteName}</span> ?</div>
                        <div className='matterport-unmap-warning-text'>This action will not delete the 3D model, but will remove the association between the model and the site.</div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1em' }}>
                          <Button variant='danger' onClick={handleMappterportUnmap}>Yes, Unmap</Button>
                          <Button variant='ghost' onClick={handleCloseMatterportUnmapWarningModal}>Cancel</Button>
                        </div>
                      </Modal.Body>
                    </Modal>

            </div>
            <div className='health-info-footer-container'>
              <Footer url={webURL}/>
            </div>
            </>
          }
          </>
        : <Home />
        }
      </>
) 
}



export default Servers;